import home from './home';
import header from './header';

export default {
  homePage: home.ar_SA,
  headerNew: header.ar_SA,
  exchange: 'منصة تداول',
  otcOrder: {
    haveCancel: 'عرض الطلبات الملغاة',
    coin: 'عملة',
    allCoin: 'الكل',
    nowOrder: 'الطلب الحالي',
    hisOrder: 'تاريخ الطلب',
    all: 'الكل',
    buy: 'شراء',
    sell: 'بيع',
    nowOrderId: 'رقم',
    nowOrderType: 'الجانب',
    nowOrderCoin: 'عملة',
    nowOrderPirce: 'السعر',
    nowOrderVolume: 'المبلغ',
    service: 'الرسوم',
    nowOrderTotol: 'مبلغ المعاملة',
    nowOrderStatus: 'الحالة',
    nowOrderUser: 'الطرف الاخر',
    hisOrderId: 'رقم',
    hisOrderType: 'الجانب',
    hisOrderCoin: 'عملة',
    hisOrderPirce: 'السعر',
    hisOrderVolume: 'المبلغ',
    hisOrderTotol: 'مبلغ المعاملة',
    hisOrderStatus: 'الحالة',
    hisOrderUser: 'الطرف الاخر',
  },
  common: {
    reload: 'إعادة تحميل',
    notData: 'لا توجد بيانات',
    error_500: 'خطأ في الخادم ، يرجى المحاولة لاحقًا',
    imgError: 'حجم الصورة كبير جدًا',
    imgFiail: 'فشل تحميل الصورة',
    pageTitleText: 'منصة تداول العملات الرقمية',
    year: 'سنة',
    mouth: 'شهر',
    zhang: 'جانغ',
    time: 'الوقت',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    search: 'بحث',
    coin: 'العملة',
    months: ['يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
    date: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  },
  phoneCode: {
    A: [
      'أفغانستان +93+4',
      'ألبانيا +355+8',
      'الجزائر +213+12',
      'ساموا الأمريكية +684+16',
      'أندورا +376+20',
      'أنغولا +244+24',
      'جزيرة أنغويلا +1264+660',
      'أنتيغوا وباربودا +1268+28',
      'الأرجنتين +54+32',
      'أرمينيا +374+51',
      'أستراليا +61+36',
      'النمسا +43+40',
      'أذربيجان +994+31',
    ],
    B: [
      'باهاماس +1242+44',
      'البحرين +973+48',
      'بنغلاديش +880+50',
      'باربادوس +1246+52',
      'روسيا البيضاء +375+112',
      'بلجيكا +32+56',
      'بليز +501+84',
      'بنين +229+204',
      'جزر برمودا +1441+60',
      'بوليفيا +591+68',
      'بوتسوانا +267+72',
      'البرازيل +55+76',
      'بروناي +673+96',
      'بلغاريا +359+100',
      'بوركينا فاسو +226+854',
      'بوروندي +257+108',
    ],
    C: [
      'كمبوديا +855+116',
      'الكاميرون +237+120',
      'كندا +1+124',
      'جزر كايمان +1345+136',
      'جمهورية أفريقيا الوسطى +236+140',
      'تشاد +235+148',
      'تشيلي +56+152',
      'كولومبيا +57+170',
      'الكونغو +242+178',
      'جزر كوك +682+184',
      'كوستاريكا +506+188',
      'ساحل العاج +225+384',
      'كوبا +53+192',
      'قبرص +357+196',
      'جمهورية التشيك +420+203',
    ],
    D: [
      'الدانمارك +45+208',
      'جيبوتي +253+262',
      'جمهورية الدومينيكان +1890+214',
    ],
    E: [
      'الإكوادور +593+218',
      'مصر +20+818',
      'السلفادور +503+222',
      'إستونيا +372+233',
      'إثيوبيا +251+231',
    ],
    F: [
      'جزر فيجي +679+242',
      'فنلندا +358+246',
      'فرنسا +33+250',
      'غويانا الفرنسية +594+254',
      'بولينيزيا الفرنسية +689+258',
    ],
    G: [
      'الجابون +241+266',
      'غامبيا +220+270',
      'جورجيا +995+268',
      'ألمانيا +49+276',
      'غانا +233+288',
      'جبل طارق +350+292',
      'اليونان +30+300',
      'غرينادا +1809+308',
      'جوام +1671+316',
      'غواتيمالا +502+320',
      'غينيا +224+324',
      'غيانا +592+328',
    ],
    H: [
      'هايتي +509+332',
      'هندوراس +504+340',
      'هونغ كونغ +852+344',
      'هنغاريا +36+348',
    ],
    I: [
      'آيسلندا +354+352',
      'الهند +91+356',
      'إندونيسيا +62+360',
      'إيران +98+364',
      'العراق +964+368',
      'أيرلندا +353+372',
      'فلسطين +972+376',
      'إيطاليا +39+380',
    ],
    J: [
      'جامايكا +1876+388',
      'اليابان +81+392',
      'الأردن +962+400',
    ],
    K: [
      'كازاخستان +7+398',
      'كينيا +254+404',
      'كوريا الشمالية +850+408',
      'كوريا الجنوبية +82+410',
      'الكويت +965+414',
      'قيرغيزستان +331+417',
    ],
    L: [
      'لاوس +856+418',
      'لاتفيا +371+428',
      'لبنان +961+422',
      'ليسوتو +266+426',
      'ليبيريا +231+430',
      'ليبيا +218+434',
      'ليختنشتاين +423+438',
      'ليتوانيا +370+440',
      'لوكسمبورغ +352+442',
      'رواندا +250+646',
    ],
    M: [
      'ماكاو +853+446',
      'مدغشقر +261+450',
      'مالاوي +265+454',
      'ماليزيا +60+458',
      'جزر المالديف +960+462',
      'مالي +223+466',
      'مالطا +356+470',
      'مارتينيك +596+474',
      'موريشيوس +230+480',
      'المكسيك +52+484',
      'مولدوفا +373+498',
      'موناكو +377+492',
      'منغوليا +976+496',
      'مونتسرات +1664+500',
      'المغرب +212+504',
      'موزمبيق +258+508',
      'ميانمار +95+104',
    ],
    N: [
      'ناميبيا +264+516',
      'ناورو +674+520',
      'نيبال +977+524',
      'هولندا +31+528',
      'جزر الأنتيل الهولندية +599+530',
      'نيوزيلندا +64+554',
      'نيكاراغوا +505+558',
      'النيجر +227+562',
      'نيجيريا +234+566',
      'النرويج +47+578',
    ],
    O: [
      'عُمان +968+512',
    ],
    P: [
      'باكستان +92+586',
      'بنما +507+591',
      'بابوا غينيا الجديدة +675+598',
      'باراغواي +595+600',
      'بيرو +51+604',
      'الفلبين +63+608',
      'بولندا +48+616',
      'البرتغال +351+620',
      'بورتوريكو +1787+630',
    ],
    Q: [
      'قطر +974+634',
    ],
    R: [
      'لا ريونيون +262+638',
      'رومانيا +40+642',
      'روسيا +7+643',
    ],
    S: [
      'سانت لوسيا +1758+662',
      'سانت فنسنت والغرينادين +1784+670',
      'ساموا +685+882',
      'سان مارينو +378+674',
      'ساو تومي وبرينسيبي +239+678',
      'المملكة العربية السعودية +966+682',
      'السنغال +221+686',
      'سيشل +248+690',
      'سيراليون +232+694',
      'سنغافورة +65+702',
      'سلوفاكيا +421+703',
      'سلوفينيا +386+705',
      'جزر سليمان +677+90',
      'الصومال +252+706',
      'جنوب أفريقيا +27+710',
      'إسبانيا +34+724',
      'سريلانكا +94+144',
      'السودان +249+736',
      'سوريا +963+760',
      'سورينام +597+740',
      'إسواتيني +268+748',
      'السويد +46+752',
      'سويسرا +41+756',
    ],
    T: [
      'تايوان +886+158',
      'طاجيكستان +992+762',
      'تنزانيا +255+834',
      'تايلاند +66+764',
      'توغو +228+768',
      'تونغا +676+776',
      'ترينيداد وتوباغو +1809+780',
      'تونس +216+788',
      'تركيا +90+792',
      'تركمانستان +993+795',
    ],
    U: [
      'أوغندا +256+800',
      'أوكرانيا +380+804',
      'الإمارات العربية المتحدة +971+784',
      'المملكة المتحدة +44+826',
      'الولايات المتحدة +1+840',
      'أوروغواي +598+858',
      'أوزبكستان +998+860',
    ],
    V: [
      'فنزويلا +58+862',
      'فيتنام +84+704',
    ],
    Y: [
      'اليمن +967+887',
    ],
    Z: [
      'زامبيا +260+894',
      'زيمبابوي +263+716',
    ],
  }, // 88
  etfAdd: {
    fundRate: 'معدل الرسوم الأساسية',
    title: 'تداول صناديق الاستثمار المتداولة (ETF)',
    dialogTitle: 'إخلاء المسؤولية',
    confirmText: 'لقد قرأت ووافقت',
    dText1: 'عزيزي العميل، مرحبًا!',
    dText3: 'شكرًا لك على تسجيل الدخول واستخدام منصتنا لتداول صناديق الاستثمار المتداولة بالرافعة المالية (ETF) والخدمات ذات الصلة (المشار إليها فيما يلي بـ "منتجات ETF"). يُرجى قراءة الوثيقة التوضيحية لمنتجات ETF والإخطارات المتعلقة بالمخاطر أدناه بعناية. إذا قمت بمواصلة استخدام منتجات ETF بعد القراءة، يُعتبر أنك قد فهمت تمامًا ووافقت على جميع مخاطر منتجات ETF وأنك قادر على تحمل الخسائر المحتملة التي يمكن أن تنجم عن استخدام منتجات ETF، وأنك توافق على كامل محتوى هذا إخلاء المسؤولية.',
    dText4: 'يرجى النقر هنا لقراءة الوثيقة التوضيحية لمنتجات ETF:',
    dText5: 'أسئلة متكررة حول منتجات ETF',
    dText6: 'إخطار المخاطر',
    dText7: '1. يجب أن لا تكون أسعار الشراء/البيع التي تقوم بها متفاوتة بشكل كبير عن صافي القيمة للوحدة، وإلا ستتعرض للخسارة المقابلة.',
    dText8: '2. في حالة تقدير الاتجاه بشكل خاطئ، قد تكون هناك مخاطر تقرب الأسعار من الصفر في الظروف السوقية القاسية.',
    dText9: 'تُحذر المنصة هنا بشدة من أن أية خسائر أو مسؤوليات ناتجة عن المخاطر المذكورة أعلاه يجب أن تكون من مسؤوليتك الشخصية، ولا تتحمل المنصة أي مسؤولية في هذا الصدد. يشكل هذا إخلاء المسؤولية بالإضافة إلى أي اتفاقيات أو بيانات أو قواعد أخرى داخل المنصة اتفاقًا كاملاً بين المنصة والعميل بشأن الخدمات والمنتجات المقدمة عبر المنصة.',
    sbyText1: '1. "3L" يعني أن ارتفاع سعر الصفقة الرئيسية بمقدار 1٪ سيؤدي إلى زيادة صافي القيمة للمنتج بنسبة 3٪.',
    sbyText2: '2. "3S" يعني أن انخفاض سعر الصفقة الرئيسية بمقدار 1٪ سيؤدي إلى زيادة صافي القيمة للمنتج بنسبة 3٪.',
    sbyText3: '3. يتم تعديل صافي القيمة بشكل يومي عند الساعة 12:00 منتصف الليل بالتوقيت المحلي، وقد يتم تعديله أيضًا خلال الجلسات التداول في حالات الأسواق القاسية.',
    sbyText4: '4. يتم فرض رسوم إدارية يومية مقابل كل رافعة مالية.',
    sbyText5: '5. يُرجى مراقبة صافي القيمة قبل التداول، حيث قد تكون هناك مخاطر في حالة انحراف السعر بشكل كبير عن صافي القيمة في الأسواق القاسية. يُرجى على المستثمرين توخي الحذر وإدارة المخاطر.',
    sbyText6: 'لمزيد من التفاصيل، يُرجى الاطلاع على الإعلانات.',
    jz: 'صافي القيمة',
    jzText1: 'صافي القيمة للاتجاه الصاعد = صافي القيمة في نقطة التعديل السابقة * [1+3*(سعر الصفقة الحالي للمنتج - سعر نقطة التعديل السابقة للمنتج) / سعر نقطة التعديل السابقة للمنتج * 100%]؛',
    jzText2: 'صافي القيمة للاتجاه الهابط = صافي القيمة في نقطة التعديل السابقة * [1-3*(سعر الصفقة الحالي للمنتج - سعر نقطة التعديل السابقة للمنتج) / سعر نقطة التعديل السابقة للمنتج * 100%]؛',
  },
  broker: {
    broker: 'نظام الوكالة',
    invitations: 'إجمالي عدد الدعوات',
    indirect: 'عدد الدعوات المباشرة',
    myType: 'نوعي',
    revenue: 'إجمالي العائد',
    export: 'تصدير المستند',
    promptText1: 'الرجاء إدخال معرف المستخدم (UID)',
    promptText2: 'الرجاء إدخال رقم الهاتف',
    promptText3: 'الرجاء إدخال البريد الإلكتروني',
    time: 'الوقت',
    phoneeNumber: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    remaid: 'سجل العمولة',
    agentAccount: 'إحصاءات المراكز المفتوحة',
    tier: 'المستوى',
    fee: 'رسوم العمولة',
    amount: 'مبلغ العائد',
    opera: 'العملية',
    ccNumber: 'حجم المركز',
    view: 'عرض',
    symbolType: 'نوع العملة',
    type: 'النوع',
    returnDetails: 'تفاصيل العائد',
    scale: 'نسبة العائد',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',
  },
  pageTitle: {
    market: 'السوق',
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    resetPass: 'استعادة كلمة المرور',
    personal: 'الملف الشخصي',
    order: 'مركز الطلبات',
    assets: 'مركز الأصول',
    trade: 'تداول العملات الرقمية',
    home: 'الصفحة الرئيسية',
    cms: 'مركز المساعدة',
    mesage: 'مركز الرسائل',
    noticeInfo: 'مركز الإعلانات',
    otcTrade: 'تفاصيل الإعلان',
    otcRelease: 'نشر إعلان',
    otcDetailOrder: 'تفاصيل الطلب',
    fiatdeal: 'تداول العملات القانونية',
    appDownload: 'تنزيل التطبيق',
    broker: 'نظام الوكالة',
    mining: 'تعدين العملات الرقمية',
    innovation: 'منطقة التجربة والابتكار',
    contract: 'تداول العقود الذكية',
    manageFinances: 'إدارة الأموال',
    manageFinancesView: 'تفاصيل إدارة الأموال',
    manageFinancesOrder: 'سجل إدارة الأموال',
    questions: 'مركز الأسئلة',
    b2cFiatdeal: 'تداول العملات القانونية',
  },
  header: {
    broker: 'نظام الوسيط',
    trade: 'تداول العملات الرقمية',
    otc: 'تداول العملات القانونية',
    lever: 'تداول بالرافعة المالية',
    co: 'تداول العقود الذكية',
    assets: 'الأصول',
    order: 'الطلبات',
    zh: 'الصينية المبسطة',
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    more: 'عرض المزيد',
    moreText: 'المزيد',
    account: 'مركز المستخدم',
    message: 'الرسائل',
    set: 'الإعدادات',
    color: 'نمط الألوان',
    userStatus: 'حالة الحساب',
    out: 'تسجيل الخروج',
    userStatus1: 'طبيعي',
    userStatus2: 'تجميد التداول وسحب الأموال مجمد',
    userStatus3: 'تجميد التداول وتجميد سحب الأموال',
    minings: 'تعدين العملات الرقمية',
    innov_tit: 'منطقة التجربة والابتكار',
    appDownLoad: 'تنزيل التطبيق',
    market: 'الأسواق',
    up_down_color: 'ألوان الارتفاع والانخفاض',
    red_up_green_down: 'ارتفاع باللون الأحمر وانخفاض باللون الأخضر',
    green_up_red_down: 'ارتفاع باللون الأخضر وانخفاض باللون الأحمر',
  },
  krwAdd: {
    bod: 'تاريخ الميلاد',
    regst1: 'بنود الخصوصية',
    regst2: 'اتفاقية المستخدم',
    regst3: 'اتفاقية استخدام التسويق والإعلان',
    regstmust: ' (إلزامي)',
    regstother: ' (اختياري)',
    hometitle: 'ملاحظات مهمة',
    hometext1: ' ',
    hometext2: ' ',
    hometext3: ' ',
    hometext4: ' ',
    hometext5: ' ',
    hometext6: ' ',
    hometext7: 'لا تظهر هذه الرسالة مرة أخرى',
    hometext8: 'موافق',
  },
  personal: {
    exccAuth: {
      errorText1: 'تم رفض التحقق. يرجى اختيار طرق أخرى لإتمام التحقق من الهوية.',
      text1: 'البلد',
      text2: 'خيار التحقق من الهوية',
      text3: 'إرسال النموذج يدويا',
      text4: 'المتابعة مع SingPass',
      text5: 'ملء النموذج يدويا.',
      text6: 'قم بتعبئة النموذج يدويًا وإرسال المعلومات وفقًا لمتطلبات المنصة.',
      text7: 'تسجيل الدخول باستخدام SingPass والإرسال.',
      text8: 'أذن بجمع المعلومات عن طريق تسجيل الدخول إلى حساب SingPass الخاص بك ، دون الحاجة إلى تعبئة النموذج. (لمواطني سنغافورة أو المقيمين الدائمين أو المقيمين الأجانب الذين يعملون محليًا.)',
    },
    exccAuthorization: {
      title: 'يرجى التحقق من معلوماتك ، التي لا يمكن تعديلها بعد الإرسال',
      title2: 'التحقق من الهوية',
      promptText1: 'الاسم المستعار',
      promptText2: 'الجنس',
      promptText3: 'رقم الهوية / تصريح الإقامة / جواز السفر',
      promptText4: 'الاسم الكامل',
      promptText5: 'الجنسية',
      promptText6: 'الوضع السكني',
      promptText7: 'تاريخ الميلاد',
      promptText8: 'بلد الميلاد',
      promptText9: ' عنوان السكن',
      promptText10: 'رقم الهاتف',
      promptText11: 'العنوان البريدي',
      promptText12: 'مصدر الدخل',
      income1: 'الراتب',
      income2: 'الاستثمارات',
      income3: 'التوفير',
      income4: 'التقاعد',
      income5: 'التركة',
      income6: 'الدعم المالي للأسرة',
      income7: 'أخرى',
      submit: 'إرسال',
    },
    exccAuthForm: {
      promptText1: 'الاسم الكامل',
      promptText2: 'الجنس',
      promptText3: 'تاريخ الميلاد',
      promptText4: 'عنوان الإقامة',
      promptText5: 'المدينة',
      promptText6: 'الرمز البريدي',
      promptText7: 'الجنسية',
      promptText8: 'رقم الهوية / تصريح الإقامة / جواز السفر',
      promptText9: 'مصدر الدخل',
      text1: 'إعادة التحميل',
      text2: ' عنوان السكن . أحدث وثيقة رسمية. يجب أن يتطابق الاسم والعنوان',
      text3: 'الرجاء تحميل جميع الصور بتنسيق jpg/png/jpeg والحجم لا يزيد عن 8MB.',
      text4: 'جميع الصور المحملة يجب أن تكون واضحة بشكل مرئي ولا يجب تعديلها أو تغييرها بأي شكل من الأشكال',
      text5: 'لا يسمح بالقبعات أو النظارات الشمسية أو أي ملحقات أخرى قد تغطي الوجه. الأمر ذاته ينطبق على المكياج. يجب أن يكون الشخص الذي يحمل الهوية له ملامح ووجهة واضحة ومميزة، مع رؤية كاملة للذراع.',
      text6: 'بالنسبة لتحميل الصورة الثالثة، يُطلب منك أن تمسك بالجزء الأمامي من بطاقة الهوية / جواز السفر / رخصة القيادة جنبًا إلى جنب مع ورقة مكتوبة بخط اليد. يجب أن تتضمن الورقة المكتوبة بخط اليد: 1) اسمك الكامل، 2) تاريخ التقديم، 3) اسم نطاق موقعنا على الويب و4) بيان لإعلان مسؤوليتك الشخصية؛ "جميع الأنشطة على هذا الموقع تتم بواسطتي وأنا على علم بالمخاطر ذات الصلة؛ وأنا مستعد لتحمل جميع العواقب القانونية".',
      text7: 'عنوان السكن. يرجى تحميل صفحة كاملة من فاتورة الخدمات (مثل الغاز أو الماء أو الكهرباء) أو كشف حساب البنك أو فاتورة الهاتف المحمول / الاتصالات أو فاتورة الإنترنت التي تحمل تاريخًا في غضون آخر 6 أشهر. تأكد من تطابق الاسم الكامل والعنوان.',
      text8: 'إعادة التحميل',
      text9: 'خلفية بطاقة الهوية / غطاء جواز السفر',
      text10: 'إعادة التحميل',
      text11: 'جزء أمامي من بطاقة الهوية / صفحة معلومات جواز السفر',
      text12: 'إعادة التحميل',
      text13: "صورة شخصية مع الهوية والملاحظة 'اسم البورصة وتاريخ اليوم'",
      text14: 'في التحقق من الهوية على المنصة، يجب أن تكون على الأقل',
      sex1: 'ذكر',
      sex2: 'أنثى',
      text15: 'الرجاء وصف مصدر الدخل',
      text16: "الرجاء إدخال تاريخ الميلاد بالتنسيق 'سنة-شهر-يوم'",
      text17: 'مثال: سنة-شهر-يوم',
      text18: 'التحقق من الهوية (KYC) مطلوب قبل التداول. يرجى تقديم طلبك للتحقق من الهوية (KYC).',
      text19: 'التحقق من الهوية (KYC) مطلوب قبل أي عملية إيداع أو سحب. يرجى تقديم طلبك للتحقق من الهوية (KYC).',
    },
    kyc: {
      areaTitle: 'الجنسية',
      area: 'حدد بلدك أو منطقتك',
      kycAuth1: 'يرجى مسح الباركود أدناه باستخدام هاتفك، افتح صفحة التحقق.',
      kycAuth2: 'التقاط صور لكلا جانبي بطاقة الهوية، سيتم إكمال التحقق بعد اجتياز التعرف على الوجه.',
      kycAuth3: 'مدة صلاحية الرمز الشريطي الباركود:',
      kycAuth4: 'لقد انتهت صلاحية الباركود، يرجى تحديث الصفحة.',
      kycAuth5: 'اكتمل التحقق',
      kycAuth6: 'هل تريد المتابعة لإكمال الشهادة على الواجهة الحالية؟',
      kycAuth7: 'موجود بالفعل',
      kycAuth8: 'يرجى مسح الباركود لإكمال التحقق',
      kycAuth9: 'يرجى إكمال التحقق من الهوية من خلال خدمة الموظفين',
      kycMin: 'دقيقة',
      kycSec: 'ثانية',
      type: 'أنواع الهوية مع الصورة',
      name: 'الاسم الأول',
      fName: 'اسم العائلة',
      text1: 'يرجى ملاحظة: مطلوب نوع واحد من الهوية مع الصورة (يفضل الجواز).',
      text2: ' ',
      type1: 'جواز السفر',
      type2: 'بطاقة الهوية',
      type3: 'رخصة القيادة',
      type4: 'هوية أخرى مع صورة',
      valueText1: 'رقم الهوية 1',
      valueText2: 'رقم الهوية 2',
      value1: 'رقم جواز السفر',
      value2: 'رقم البطاقة',
      value3: 'رقم رخصة القيادة',
      value4: 'رقم الهوية الأخرى مع الصورة',
      Optional: 'اختياري',
      require: 'مطلوب',
    },
    krw: {
      authType: 'كوريا',
      authOther: 'أجنبي',
      auth: 'التحقق',
      niceN: 'التحقق من الهوية عبر الهاتف المحمول (إدخال التحقق الكوري)',
      niceText: 'يستخدم للتأكد من معلومات هويتك على المنصة',
      bank: 'بطاقة البنك',
      bankText: 'يمكنك السحب بعد الربط',
      authLevel: 'التحقق من الهوية',
      authLevelText: 'لأمان أصولك، يرجى إكمال التحقق في أقرب وقت ممكن',
      account: 'الحساب',
      selectArea: 'يرجى اختيار جنسيتك',
      niceConfrim: 'تم التحقق',
      niceConfrimTitle: 'التحقق من الهوية عبر الهاتف ',
      niceConfrimText: 'التحقق من الهوية عبر الهاتف ، في الانتظار...',
      alertText: 'من أجل أمان حسابك، يرجى إتمام الإجراءات التحقق التالية',
      inow: 'أعرف',
      alertk: 'التحقق من الهوية عبر الهاتف أو التحقق من الهوية',
      OTPk: 'تحقق OTP',
      phonek: 'يرجى تحسين التحقق من هوية هاتفك المحمول أولاً',
    },
    krwBank: {
      addBank: 'ربط حساب البنك',
      setBank: 'تغيير حساب البنك',
      userName: 'الاسم',
      country: 'الدول',
      bankAccount: 'رقم حساب البنك',
      bankAccountError: 'الرجاء إدخال رقم الحساب البنكي الصحيح',
      smsCode: 'رمز التحقق عبر الرسالة النصية',
      smsCodeError: 'الرجاء إدخال رمز التحقق المكون من 6 أرقام الذي تم إرساله بالرسائل النصية',
      googleCode: 'رمز التحقق من مصادقة جوجل',
      googleCodeError: 'الرجاء إدخال رمز التحقق من مصادقة جوجل المكون من 6 أرقام',
    },
    label: {
      smsCodeText: 'رمز التحقق',
      googleCodeText: 'رمز تحقق جوجل',
      emailCodeText: 'رمز تحقق البريد الإلكتروني ',
      newEmailCodeText: 'رمز تحقق البريد الإلكتروني الجديد',
      moneyPassword: 'كلمة مرور الأصول',
      oldMoneyPassword: 'كلمة مرور الأصول الجديدة',
      newConfirmMoneyPassword: 'تأكيد كلمة مرور الأصول',
      confirmMoneyPassword: 'تأكيد كلمة مرور الأصول الجديدة',
      ipText: 'عنوان الـ IP',
      noteText: 'ملاحظات',
      promptText: 'الجنسية',
      errorText: 'اختيار البلد',
      phone: 'رقم الهاتف',
      oldPhone: 'رقم الهاتف',
      newPhone: 'رقم الهاتف الجديد',
      oldPassword: 'كلمة المرور',
      password: 'كلمة المرور',
      newPassword: 'كلمة المرور الجديدة',
      newPasswordAgain: 'تأكيد',
      oldEmail: 'البريد الإلكتروني',
      newEmail: 'البريد الإلكتروني الجديد',
      email: 'البريد الإلكتروني',
      idCard: 'بطاقة الهوية',
      idCardNum: 'رقم الهوية',
      promptText1: 'العنوان',
      passport: 'جواز السفر',
      name: 'الاسم',
      inviteCode: 'رمز الدعوة',
      inviteUrl: 'رابط الدعوة',
      inviteQECode: 'رمز دعوة الاستجابة السريعة',
      inviteTitle: 'دعواتي',
    },
    tool: {
      modify: 'تغيير',
      bind: 'اتصال',
      delete: 'حذف',
      setUp: 'الإعدادات',
      add: 'أضافة',
      submit: 'أرسل',
      create: 'إنشاء',
      view: 'عرض',
      confirm: 'تأكيد',
    },
    prompt: {
      errorTextName: 'لا يمكن أن يكون الاسم المستعار فارغًا',
      errorTextLength: 'لا يمكن أن يتجاوز طول الاسم المستعار العشرة حروف',
      ipErrorText: 'الرجاء إدخال عنوان IP الصحيح',
      copySucces: 'تم النسخ',
      errorCode: 'يرجى إدخال رمز التحقق',
      errorPhone: 'يرجى إدخال رقم الهاتف الصحيح',
      errorPhoneText: 'الرجاء إدخال رقم الهاتف الخاص بك',
      errorNewPhone: 'يرجى إدخال رقم هاتف جديد',
      ipCode: 'الرجاء إدخال عنوان IP الصحيح',
      noteCode: 'الرجاء كتابة تعليق',
      uploading: 'جار التحميل',
      uploadQrCod: 'تحميل صورة الباركود',
      uploadQrCodAgain: 'يرجى رفع الباركود مرة أخرى',
      uploadType: 'دعم jpg / png ، بحجم أقل من 8M',
      warningApi: 'يرجى عدم الكشف عن المفتاح للآخرين لتجنب خسارة الأصول. يمكن للمستخدم الفردي إنشاء ما يصل إلى 5 مفاتيح. يوصى بربط IP بالمفتاح. يتم ربط كل مفتاح بحد أقصى 5 عناوين IP، مفصولة بفواصل',
      warningChangePhone: 'لا يمكن إجراء سحب في غضون 24 ساعة بعد تعديل الهاتف.',
      warningChangePassword: 'لا يمكن إجراء سحب في غضون 24 ساعة بعد تعديل كلمة المرور لتسجيل الدخول.',
      warningChangeEmail: 'لا يمكن إجراء سحب في غضون 24 ساعة بعد تعديل البريد الإلكتروني.',
      warningPassword: 'لا يمكن إجراء سحب في غضون 24 ساعة بعد تغيير كلمة مرور الاصول',
      errorPasswordText: 'الرجاء إدخال من 8 إلى 20 رمزا، يتضمن الأرقام والحروف',
      errorPasswordTwo: 'كلمات المرور غير متطابقة',
      errorEmailText: 'الرجاء إدخال البريد الإلكتروني الصحيح',
      errorEmail: 'الرجاء إدخال بريدك الإلكتروني',
    },
    state: {
      certification: 'التحقق',
      certified: 'موثق',
      authentication: 'جارٍ التحقق',
      closeValidatio: 'إغلاق',
      openValidatio: 'فتح',
      open: 'مفتوحة بالفعل',
      closeSuccess: 'تم الإغلاق بنجاح',
      openSuccess: 'تم التشغيل بنجاح',
      release: 'قيد النشر',
      trading: 'التداول',
      overdue: 'متأخر',
      close: 'مغلق',
      closed: 'تم الإغلاق',
    },
    alert: {
      title: 'لأمان حسابك، يرجى تفعيل طريقة تحقق واحدة على الأقل.',
      button: 'الإعدادات',
      fiatTitle: 'تذكير بإعداد العملة النقدية',
      buttonOpen: 'تفعيل',
      certif: 'التحقق',
      text: 'لأمان حسابك، يرجى فتح طريقة تحقق واحدة على الأقل.',
      enforceGoogleAuth: 'يرجى إكمال التحقق من الهوية، وضبط الاسم المستعار وفتح التحقق من جوجل أولا قبل إضافة طريقة الدفع وضبط كلمة مرور الأصول.',
      fiatText: 'يرجى التحقق باسمك الحقيقي، و إعداد الاسم المستعار و فتح طريقة التحقق الأمنية واحدة على الأقل لإضافة طرق الدفع وإعداد كلمات مرور الأصول.',
      alertErrorTextGoogle: 'ربط التحقق من جوجل',
      alertErrorTextPhone: 'ربط التحقق من الهاتف المحمول',
      nickName: 'الاسم المستعار',
      id: 'التحقق',
      textOpen: 'يرجى ربط وتفعيل طريقة الدفع واحدة على الأقل، بعد ذلك يمكنك بيع العملة الرقمية',
      payTypeError: [
        'يمكن الدفع للمشترون عبر',
        ' الرجاء اختيار وإضافة طريقة الدفع وتفعيلها.',
      ],
    },
    dialog: {
      title: 'تغير الاسم المستعار',
      name: 'الاسم المستعار',
      text: 'الرجاء إدخال الاسم المستعار',
      closeAd: 'أغلاق الإعلان',
      closeAdPrompt: 'سيؤدي إغلاق الإعلان إلى إيقاف التداول علية. هل أنت متأكد أنك تريد إغلاق هذا الإعلان؟',
      blackPrompt: 'تذكير',
      blackPromptText: 'هل أنت متأكد أنك تريد إزالة هذا الحساب من قائمة الحظر الخاصة بك؟',
    },
    navMenu: {
      title: 'حسابي',
      list: {
        inviteCodeManagement: 'إدارة كود الدعوة',
        userManagement: 'إدارة الحساب',
        safetyRecord: 'سجل الأمان',
        leaglTenderSet: 'إعدادات العملة النقدية',
        advertisingManagement: 'إدارة الإعلانات',
        blackList: 'القائمة السوداء',
        apiManagement: 'إدارة API',
      },
    },
    userManagement: {
      nameError1: 'الاسم المستعار لا يمكن أن يكون فارغا',
      nameError2: 'لا يمكن أن يتجاوز الاسم المستعار عشرة حروف',
      nameError3: 'مسموح فقط بالأحرف الإنجليزية، والأرقام (0-9)، والرموز الخاصة ("-","_")',
      userName: 'الاسم المستعار',
      id: 'معرف',
      securityTitle: 'إعدادات الأمان',
      otherTitle: 'أخرى',
      inviteLink: 'دعواتي',
      securityList: {
        password: {
          text: 'كلمة مرور الدخول',
          label: '***********',
        },
        idAuth: {
          text: 'التحقق من الهوية',
          label: 'يرجى البدء في تحقق الهوية الخاصة بك',
        },
        email: {
          text: 'البريد الإلكتروني',
          label: 'يستخدم عند تسجيل الدخول، والسحب، وتعديل إعدادات الأمان',
        },
        phone: {
          text: 'رقم الهاتف',
          label: 'تلقي الرسائل النصية المستخدمة للسحب، وتغيير كلمة المرور أو تغيير إعدادات الأمان.',
        },
        google: {
          text: 'مصادق جوجل ',
          label: 'التحقق الأمني لـ API عند السحب، واسترداد كلمات المرور، وتعديل إعدادات الأمان وإدارة API',
        },
      },
      otherList: {
        poundage: {
          text: 'يمكن دفع الرسوم باستخدام العملات للسوق و رسوم التداول',
          label: 'يستخدم كوحدة سوق الصرف، وحدة العملة التداول',
        },
        myInviteCod: {
          text: 'كود الدعوة الخاص بي',
          label: 'ادعو مستخدمين جدد، اكسب المكافآت!',
        },
        myInvite: {
          text: 'دعواتي',
          // label: 'يستخدم لدعوة مستخدمين جدد',
        },
        superPeerCod: {
          text: 'العقدة الفائقة',
          // label: 'يستخدم لدعوة مستخدمين جدد',
        },
        superDeputyCod: {
          text: 'الوكيل الرئيسي',
          // label: 'يستخدم لدعوة مستخدمين جدد',
        },
      },
    },
    safetyRecord: {
      navTab: [
        'سجلات الدخول',
        'سجلات إعدادات الأمان',
      ],
      loginColumn: [
        'الوقت',
        'النوع',
        'عنوان الـ IP',
        'الحالة',
      ],
      settingColumn: [
        'الوقت',
        'إعدادات الأمان',
        'عنوان الـ IP',
      ],
      success: 'ناجح',
      failure: 'فشل',
    },
    inviteCodeManagement: {
      title: 'ادعو أصدقاءك واحصل على عمولة من تداولاتهم',
      titleText: 'يمكن الاطلاع على قواعد الدعوات من لمعرفة المزيد من التفاصيل',
      showNumber: 'عدد المدعوين',
      showCommission: 'العمولة',
      commissionWay: 'طريقة الدعوة',
      commissionRecor: 'سجل الدعوات',
      columns: [
        'الوقت',
        'الحساب المدعو',
      ],
    },
    leaglTenderSet: {
      title: 'إدارة طرق الدفع',
      titleList: [
        {
          text: 'إعدادات طريقة الدفع',
          label: 'يرجى استخدام حسابك الموثق. سيتم عرض طرق الدفع المفعلة للمشتري أثناء العملية، يمكن تفعيل ما يصل إلى 3 طرق دفع.',
        },
        {
          text: 'كلمة مرور الأصول',
          label: 'لضمان أمان أصولك، يرجى إعداد كلمة مرور الأصول',
        },
      ],
    },
    setUp: {
      title1: 'إعداد طريقة الاستلام',
      title2: 'إضافة طريقة استلام',
      hint: 'يمكن ربط كل عملة نقدية ببطاقة بنكية، يمكن ربط ما يصل إلى 4 بطاقات بنكية',
      paymentMethods: {
        text: 'طريقة الاستلام',
        errorText: 'يرجى اختيار طريقة الاستلام',
        text2: 'العملة النقدية',
        errorText2: 'يرجى اختيار نوع العملة النقدية',
        paymentsWA: {
          name: 'الاسم',
          title: 'الحساب',
          type: 'نوع الحساب',
        },
        paymentsCard: {
          name: 'الاسم',
          bank: 'اسم البنك',
          branch: 'معلومات الفرع (اختياري)',
          branchInfo: 'معلومات الفرع',
          account: 'حساب البنك',
          swiftCode: 'رقم SWIFT',
          ibanNumber: 'رقم IBAN',
        },
        buyerUse: 'وقد استخدم المشتري',
      },
    },
    advertisingManagement: {
      navTab: [
        'إعلانات الشراء',
        'إعلانات بيع',
      ],
      columns: [
        'الوقت',
        'رقم الإعلان',
        'العملة',
        'السعر',
        'الكمية',
        'الحالة',
      ],
    },
    APImanagement: {
      navTab: [
        'إنشاء مفتاح API',
        'وثيقة الاقتباس API',
        'وثيقة المعاملات API',
      ],
      columns: [
        'ملاحظات',
        'عنوان IP للاتصال',
        'API مفتاح',
        'Secretkey - مفتاح الامان',
        'العملية',
      ],
      columnsApi: [
        'الواجهة',
        'الوصف',
      ],
      recordTitle: 'سجل API',
      downloadDocumen: 'تحميل الوثيقة',
      titleText: 'تأكيد المفتاح',
      secretKey: 'Secretkey - مفتاح الامان',
      APIKye: 'API مفتاح',
      ip: 'عنوان IP',
      note: 'ملاحظات',
      apiList: [
        'الحصول على بيانات الخط K',
        'سجل المعاملات',
        'استعلام عمق الطلب',
        'جميع الطلبات',
        'جميع سجلات المعاملات',
        'إلغاء الطلب',
        'الاستعلام عن جميع أزواج المعاملات ودرجة الدقة التي يدعمها النظام',
        'إنشاء طلب',
        'الحصول على أحدث سعر للمعاملة لجميع أزواج العملات',
        'الطلب المفتوح',
        'تفاصيل الطلب',
        'رصيد الأصول',
      ],
    },
    checkApi: {
      title: 'عرض مفتاح الامان SecretKey',
    },
    modifyApi: {
      title: 'تعديل APIKey',
    },
    changePhone: {
      title: 'تغيير رقم الهاتف',
    },
    changePassword: {
      title: 'تعديل كلمة مرور الدخول',
    },
    changeEmail: {
      title: 'تعديل البريد الإلكتروني',
    },
    bindEmail: {
      title: 'ربط البريد الإلكتروني',
    },
    bindGoogle: {
      title: 'ربط التوثيق الخاص بـجوجل',
      downloadGoogle: [
        'قم بتنزيل تطبيق مصادقة جوجل',
        'يمكن لمستخدمي سوق تطبيق الايفون تسجيل الدخول إلى متجر التطبيقات والبحث عن مصادق للتنزيل. يمكن لمستخدمي اندرويد البحث عن مصادقة جوجل للتنزيل باستخدام متجر التطبيقات أو متصفح الهاتف المحمول',
      ],
      useGoogle: [
        'استخدم مصادقة جوجل لمسح رمز الباركود أو أدخل المفتاح يدويًا',
        'افتح مصادقة جوجل، قم بمسح رمز الباركود الموجود أدناه أو أدخل المفتاح التالي يدويًا لإضافة رمز التحقق',
      ],
      bindGoogle: [
        'اكمل الربط',
        'يُستخدم المفتاح لاسترداد مصادقة جوجل عند استبدال الهاتف أو فقده. تأكد من حفظ نسخة احتياطية من المفتاح الموجود أعلاه قبل الربط.',
      ],
      appStore: 'متجر التطبيقات',
      googlePlay: 'سوق التطبيقات',
      android: 'أندرويد',
    },
    bindPhone: {
      title: 'ربط الهاتف المحمول',
    },
    closeGoogle: {
      title: 'تعطيل مصادقة جوجل',
    },
    closePhone: {
      title: 'تعطيل التحقق من الهاتف المحمول',
    },


    idAuth: {
      title: 'التحقق',
      info: 'المعلومات الأساسية',
      uploadDocuments: 'تحميل الوثائق',
      submitted: 'مقدمة',
      promptTextType: 'نوع الوثيقة',
      next: 'التالي',
      uploadIdCardPositive: 'واجهة الهوية الخاصة بك 1',
      uploadIdCardPositiveAgain: 'تحميل الواجهة الأمامية للصورة مرة أخرى',
      uploadIdCardBack: 'خلفية هويتك 1 (لا يحتاج جواز السفر إلى تقديم الخلفية)',
      uploadIdCardBackAgain: 'تحميل الجانب الخلفي للصورة مرة أخرى',

      uploadIdCardPositive2: 'واجهة الهوية الخاصة بك 2',
      uploadIdCardPositiveAgain2: 'تحميل الواجهة الأمامية للصورة مرة أخرى',
      uploadIdCardBack2: 'خلفية هويتك 2',
      uploadIdCardBackAgain2: 'تحميل الجانب الخلفي للصورة مرة أخرى',

      uploadIdCardPersonalPositiv: 'الهوية وصورة التوقيع الشخصي',
      uploadIdCardPersonalPositivAgain: 'تحميل الهوية والتوقيع الشخصي مرة أخرى',

      uploadAddress: 'إثبات السكن',

      uploadPassportPositive: 'تحميل الغلاف الأمامي لوثيقة الهوية',
      uploadPassportPositiveAgain: 'تحميل الغلاف الأمامي لجواز السفر مرة أخرى',
      uploadPassportBack: 'تحميل صفحة المعلومات الشخصية لوثيقة الهوية',
      uploadPassportBackAgain: 'تحميل صفحة المعلومات الشخصية لجواز السفر مرة أخرى',

      uploadPassportPersonalPositiv: 'صورة لحمل الوثيقة والتوقيع الشخصي',
      uploadPassportPersonalPositivAgain: 'صورة لحمل الوثيقة والتوقيع الشخصي مرة أخرى',

      uploadText: [
        'يدعم الصور بتنسيق JPG أو JPEG أو PNG التي تقل عن 8 ميجابايت.',
        'يجب أن تكون صورة الهوية واضحة، غير معدلة، وغير مغطاة، مع ميزات الوجه الواضحة، رقم الهوية، والاسم.',
        'يجب أن يتم التقاط الصورة بدون قبعة ومكياج، ويجب أن يكون للشخص الذي يحمل الهوية ميزات الوجه الواضحة ويظهر كامل ذراعه.',
        'إثبات العنوان: إما العنوان الموجود على البطاقة الشخصية أو عنوان صالح.',
        'الهوية المحمولة باليد والملاحظة المكتوبة بخط اليد: صورة للمتقدم يحمل الهوية وملاحظة مكتوبة بخط اليد تقول "الاسم + تاريخ التقديم',
      ],
      wait: [
        'تم تقديم معلومات هويتك',
        'يرجى الانتظار بصبر، يتم مراجعة معلوماتك.',
      ],
      step1: '1. يرجى تنزيل التطبيق المحمول وإكمال عملية التحقق من الهوية في التطبيق.',
      step2: '2. افتح المركز الشخصي في التطبيق في الهاتف المحمول واتبع الإرشادات لإكمال خطوات التحقق.',
      appDownLoad: 'امسح الباركود لتنزيل التطبيق',
    },
    modifySettings: {
      setTitle: 'إعداد كلمة مرور الأصول',
      modifyTitle: 'تعديل كلمة مرور الأصول',
    },
  },
  fiatdeal: {
    title: 'بيع وشراء',
    paySetting: 'إعدادات الدفع',
    myOrder: 'طلباتي',
    myAd: 'إعلاناتي',
    openA: [
      'المزيد',
      'أقل',
    ],
    navList: [
      'P2P',
      'شراء',
      'بيع',
      'التداول بالجملة',
      'بيع',
      'شراء',
      'نشر إعلان',
      'تقديم طلب كتاجر',
    ],
    center: {
      header: {
        text: 'آخر سعر متوسط للتداول',
      },
      country: 'البلد',
      fiat: 'عملة نقدية',
      payment: 'طريقة الدفع',
      idinfo: 'قبل أن تتداول، يرجى إكمال التحقق من الهوية وإعدادات الأمان',
      columns: [
        'التاجر',
        'المتاح',
        'الحدّ',
        'السعر',
        'طريقة الدفع',
        'العملية',
      ],
      buy: 'شراء',
      sell: 'بيع',
      trading: 'التداول',
      credit: 'التقييم',
      all: 'الكل',
    },
  },
  stranger: {
    addBlackList: 'إضافة إلى القائمة السوداء',
    removeBlackList: 'إزالة من القائمة السوداء',
    online: 'متصل',
    offline: 'غير متصل',
    already: 'تم',
    never: 'أبدا',
    phone: 'رقم الهاتف',
    identity: 'الهوية',
    certification: 'تحقق',
    headerList: [
      'عدد المعاملات',
      'حجم بلاغات',
      'البلاغات الناجحة',
    ],
    blackListPrompt: [
      'تأكيد الإضافة إلى القائمة السوداء؟',
      'تأكيد الإزالة من القائمة السوداء؟',
    ],
    navTab: [
      'إعلان الشراء',
      'إعلان البيع',
    ],
    columns: [
      'العملة',
      'المتاح',
      'الحد',
      'السعر',
      'طريقة الدفع',
      'العملية',
    ],
    buy: 'شراء',
    sell: 'بيع',
    view: 'عرض',
  },
  home: {
    more: 'المزيد',
    searchSy: 'البحث عن العملة',
    market: 'السوق',
    close: 'آخر سعر',
    applies: 'التغير النسبي',
    height: 'أعلى سعر',
    low: 'أدنى سعر',
    H_volume: 'الحجم خلال 24 ساعة',
    H_turnover: 'الإيرادات خلال 24 ساعة',
    action: 'الإجراء',
    marketSet: 'المفضلة',
    chart: 'الرسم البياني',
    moreMarket: 'عرض المزيد من التداول',
    bitsgtitle1: 'أي عملة تريد',
    bitsgtitle2: 'العملات الشائعة',
    bitsgtitle3: 'للتداول',
    H_coNumber: 'عدد المراكز',
    tab_USDT: 'عقود USDT',
    tab_USD: 'عقود العملة الأساسية',
  },
  trade: {
    dataType1: 'الإصدار الأساسي',
    dataType2: 'الإصدار المتقدم',
    dataType3: 'مخطط العمق',
    datatext1: 'افتتاح',
    datatext2: 'أعلى',
    datatext3: 'أدنى',
    datatext4: 'إغلاق',
    datatext5: 'الكمية',
    noUnlock: 'لم يتم فك قفل الإيداع',
    freeUnlock: 'لم يتم فك قفل الهدية',
    ySellVol: 'الكمية القابلة للبيع',
    unlockSellBtn: 'فك قفل البيع بنقرة واحدة',
    modelInfo: ' شرح النموذج',
    sellAll: 'عرض الكل',
    balance: 'الرصيد المتاح',
    currencyNotesModal: {
      coinType: 'اختصار العملة',
      fullNameCurrency: 'الاسم الكامل للعملة',
      issueTime: 'وقت الإصدار',
      totalIssueAmount: 'إجمالي الكمية المصدرة',
      totalCirculation: 'إجمالي التداول',
      officialWebsite: 'الموقع الرسمي',
      blockQuery: 'استعلام الكتلة',
      Introduction: 'مقدمة',
      relatedLinks: 'روابط ذات صلة',
    },
    searchSy: 'البحث عن العملة',
    market: 'السوق',
    close: 'آخر سعر',
    applies: 'التغير النسبي',
    height: 'أعلى سعر',
    low: 'أدنى سعر',
    vol: 'الكمية',
    H_volume: 'الحجم خلال 24 ساعة',
    H_turnover: 'الإيرادات خلال 24 ساعة',
    marketSet: 'المفضلة',
    maincon: 'المنطقة الرئيسية',
    halving: 'منطقة التنصيف',
    newcon: 'المنطقة المبتكرة',
    seecon: 'المنطقة الراصدة',
    unseal: 'منطقة إلغاء الإغلاق',
    notData: 'لا توجد بيانات حاليًا',
    handicap: 'السوق',
    latestDeal: 'آخر صفقة',
    price: 'السعر',
    number: 'الكمية',
    total: 'التراكمي',
    time: 'الوقت',
    activeOrder: 'الأمر الحالي',
    historyOrder: 'الأوامر السابقة',
    class: 'الفئة',
    transaction: 'زوج التداول',
    average: 'متوسط السعر',
    status: 'الحالة',
    opera: 'العمليات',
    deal: 'تم التنفيذ',
    noDeal: 'لم يتم التنفيذ',
    turnover: 'إيرادات التداول',
    serviceCharge: 'الرسوم',
    marketPrice: 'السعر السوقي',
    cancelOrder: 'إلغاء الأمر',
    cancelled: 'تم الإلغاء',
    view: 'التفاصيل',
    dealMoney: 'قيمة التداول',
    limitPriceTrade: 'تداول محدد السعر',
    marketPriceTrade: 'تداول بالسعر السوقي',
    total_money: 'الأصول المكافئة',
    buy: 'شراء',
    sell: 'بيع',
    loginReg: 'تسجيل الدخول / التسجيل',
    mPriceBuy: 'شراء بأفضل سعر سوقي',
    mPriceSell: 'بيع بأفضل سعر سوقي',
    pleaseLogin: 'يرجى تسجيل الدخول أولاً',
    pleasePrice: 'يرجى إدخال السعر',
    pleaseInput: 'يرجى الإدخال',
    inputError: 'خطأ في الإدخال',
    dealCussess: 'تم إرسال الأمر بنجاح',
    full: 'ملء الشاشة',
    outFull: 'الخروج من وضع ملء الشاشة',
  },
  message: {
    mesage: 'مركز الرسائل',
    noticeInfo: 'مركز الإعلانات',
    help_center: 'مركز المساعدة',
    selectAll: 'تحديد الكل',
    delete: 'حذف',
    readAll: 'تمييز الكل كمقروء',
    pleSelContent: 'يرجى تحديد المحتوى للحذف',
    search: 'بحث',
  },
  application: {
    policy: {
      title: 'اتفاقية التاجر المعتمد',
      desc: 'منصة مال - بيع وشراء OTC\n لضمان أمان كل طرفين في الصفقة وتعزيز مصداقية هوية المستخدمين المسجلين في المنصة، نقدم لك خدمة توثيق التاجر. يجب عليك تقديم معلوماتك الشخصية الحقيقية الضرورية لإتمام عملية التوثيق. تحتفظ المنصة بالحق في اتخاذ جميع الإجراءات القانونية اللازمة للتحقق من المعلومات التي قدمتها. ومع ذلك، نظرًا للطابع الافتراضي للبيئة الإلكترونية وقيود طرق التحقق، لا تقدم المنصة أي ضمان بشأن دقة وحقيقة هوية التاجر المعتمد.\n جميع أحكام هذه الاتفاقية ذات الصلة في المحتوى تتعلق بحقوقك وواجباتك. يرجى قراءة جميع أحكام هذه الاتفاقية بعناية قبل البدء في عملية طلب التوثيق كاملة. إذا بدأت عملية التوثيق، فهذا يعني أنك على علم بالمحتوى وتفهمه بشكل كامل، وتوافق على جميع أحكام هذه الاتفاقية.\n الجزء الأول: تعريف وتغيير خدمة التوثيق\n 1. تعريف خدمة التوثيق: هي الخدمة التي تتيح للتاجر تقديم معلومات هويته الحقيقية والموثوقة ودفع مبلغ معين كضمان، ليتمتع بامتيازات معينة في المنصة ويتحمل واجبات محددة. ما لم يكن هناك متطلبات قانونية أو اتفاقات خاصة بخلاف ذلك، فبمجرد أن تكمل عملية التوثيق على المنصة، لا يمكن تعديل أو إلغاء معلومات هوية التاجر المعتمد أو نتائج التوثيق لأي سبب من الاسباب؛ إذا تغيرت معلومات هويتك بعد الانتهاء من عملية التوثيق، يجب عليك تقديم وثائق صادرة عن الجهة المختصة تثبت هذا التغيير وسيقدم المنصة المساعدة في تحديث معلومات التوثيق.\n 2. تغيير خدمة التوثيق: تحتفظ المنصة بحق تعديل أو تعديل محتوى هذه الاتفاقية وفقًا للظروف الواقعية والموضوعية، وتنشر نص الاتفاقية المعدلة في المنصة كإعلان، من دون الحاجة إلى إشعارك بشكل منفصل. باستمرارك في استخدام الخدمات المقدمة من المنصة بعد أي تعديل أو تغيير في هذه الاتفاقية، فإن ذلك يعني موافقتك على قراءة وفهم وقبول محتوى الاتفاقية المعدلة. إذا كنت لا توافق على محتوى الاتفاقية المعدلة أو المعدل منها، يجب أن تقدم طلبًا فوريًا لإلغاء خدمة التوثيق.\n الجزء الثاني: حقوق التاجر المعتمد\n 1. تقديم علامة توثيق التاجر: سيتم تقديم علامة خاصة للتاجر الذين تمت الموافقة على توثيقهم، يمكن استخدام هذه العلامة للتفريق بين التجار المعتمدين وغير المعتمدين على المنصة.\n 2. نشر معلومات الصفقة المطابقة للمتطلبات على المنصة.\n الجزء الثالث: المعلومات المطلوبة للتوثيق وضمانات الوديعة\n 1. معلومات الشخصية للتاجر: يُرجى تقديم المعلومات المطلوبة بالكامل وتحميلها كملف مرفق.\n 2. وديعة الضمان: لتوثيقك كتاجر معتمد، يجب دفع مبلغ معين كضمان وديعة. ستُحول هذه الوديعة إلى حساب الضمان التابع لحسابك التجاري. خلال فترة معينة، لن يمكنك التداول أو تحويل الأموال من هذا الحساب.\n الجزء الرابع: استخدام المعلومات الموثقة\n تقر بتقديم المعلومات الموثقة للمنصة أثناء عملية التوثيق، وتمنحها حق الاحتفاظ بها بشكل لا يمكن عكسه. باستثناء الحالات القانونية أو الاتفاقيات الأخرى المعتمدة بخلاف ذلك، تلتزم المنصة بعدم تحرير أو نشر معلومات التوثيق لأي طرف ثالث، ولا تستخدمها لأغراض تجارية، ولكن هذا لا يشمل ما يلي:\n 1. إذنك بالكشف عن المعلومات المتعلقة؛\n 2. تقديمها للسلطات القضائية والإدارية؛\n 3. تقديمها لشركات المرتبطة بالمنصة؛\n 4. تقديم المعلومات التي تحتاجها الجهة الثالثة لتقديم الخدمات لك في تعاملاتها معك (باستثناء معلومات حسابك المصرفي)؛\n 5. من أجل حل نزاع مدني بينك وبين جهة ثالثة، تحتفظ المنصة بالحق في تقديم معلومات هويتك لهذه الجهة.\n الجزء الخامس: استخدام وديعة الضمان\n تُستخدم وديعة الضمان لتأمين سلامة الصفقات المجاورة على المنصة. في حالة حدوث نزاع أثناء عملية التداول، وتحديد أنك مسؤول عن النزاع وعدم التعاون من جانبك، تحتفظ المنصة بحق التصرف في وديعة الضمان، ويشمل ذلك وليس بالاقتصار على الاحتجاز أو التجميد، أو الدفع المباشر للطرف الآخر للصفقة.\n الجزء السادس: روابط المواقع الطرفية\n قد تحتوي المنصة على روابط إلى مواقع طرفية (مثل مواقع البنوك الإلكترونية) لأغراض التحقق من هويات المستخدمين. هذه "الروابط" ليست تحت سيطرة المنصة، ولا تتحمل المنصة أية مسؤولية عن محتوى أو أي روابط ضمن "الروابط" أو أي تغييرات أو تحديثات لهذه الروابط. المنصة لا تتحمل مسؤولية نقل "الروابط" أو أي انتقال آخر من شأنه تداول المحتوى بأي وسيلة. \n الجزء السابع: الاستخدام الغير قانوني أو المحظور\n قبول جميع التفسيرات والشروط والأحكام الواردة في هذه الاتفاقية هو شرط أساسي لتقديم طلب التوثيق. تعهد وتضمن أنك لن تستخدم خدمة التوثيق لأي غرض غير قانوني أو محظور بموجب هذه الاتفاقية أو الشروط والأحكام أو التعليمات الواردة. على سبيل المثال ودون الحصر، لن تستخدم خدمة التوثيق للقيام بأي نشاط يسبب ضررًا أو إعاقة أو تحميل زيادة غير معقولة على المنصة أو مواقع طرفية أخرى أو استخدامها بطرق تعيق استخدام خدمة التوثيق للآخرين.\n الجزء الثامن: الإعفاء من المسؤولية\n لن تكون المنصة مسؤولة عن تسرب أو كشف المعلومات الشخصية بناءً على الحالات التالية: \n 1. إذا قمت بإفشاء كلمة مرور حسابك للآخرين أو لم تحافظ على سرية كلمة المرور أو شاركتها مع أي شخص آخر أو أظهرت أي سلوك غير لائق أو مشتركة حسابك مع الآخرين، مما أدى إلى كشف المعلومات الشخصية.\n 2. أي تأثير ناتج عن هجمات القرصنة الإلكترونية أو الفيروسات الحاسوبية أو التداخلات التقنية من قبل وزارة الاتصالات أو أثر تعديلات سياسات الاتصالات أو أي سبب آخر يؤدي إلى إلحاق ضرر بالمعلومات أو تسريبها، بما في ذلك إغلاق الموقع نتيجة لسياسة الحكومة أو القانون.\n 3. تأثير أي إغلاق للموقع الذي يتصل بالمنصة (مثل مواقع البنوك الإلكترونية) يؤدي إلى تسرب معلومات حسابك المصرفي وجميع النتائج والتبعات القانونية الناجمة عنها.\n 4. أي خسائر تحدث بسبب تقديمك لمعلومات غير صحيحة أو غير كاملة أو غير صادقة أو أي نوع آخر من الخسائر الناتجة عن العمليات الاحتيالية.\n الجزء التاسع: بيان خاص\n 1. تُعرض مراجعة المعلومات الأساسية وضمان الوديعة للتوثيق لا يعني أن التاجر معتمد بنسبة 100%، ولا يعني أن المنصة والتاجر معتمد على بعضهما البعض بأي شكل من الأشكال. يُرجى التزام المستخدمين بإجراءات التداول المحددة وإجراءات التحقق من هوية الأطراف المتداولة والتواصل الوافي لضمان سلامة التعاملات والأصول الخاصة بهم. ونظرًا للطبيعة الخاصة لتداول الأصول الرقمية، يجب مراعاة المخاطر المتعلقة بمكافحة غسيل الأموال وفقًا لمبدأ "معرفة عميلك". في حالة عدم الامتثال لهذه المبادئ، قد تواجه مخاطر تجميد الأصول.\n 2. يلتزم التاجر المعتمد بتقديم معلومات حقيقية وقانونية للمنصة، وإذا تبين أنه قدم معلومات زائفة أو غير قانونية، فإن المنصة لديها الحق في إلغاء توثيقه واحتجاز وديعته.\n الجزء العاشر: إنهاء التوثيق\n إذا كنت بحاجة لإلغاء التوثيق كتاجر معتمد، يجب تقديم طلب إلى المنصة. إذا كان لديك سجل نظيف خلال فترة التوثيق ولم تؤثر سلامة التداول أو ارتكبت أي مخالفات قانونية أو غير قانونية، ستتم مراجعة الطلب في غضون يومي عمل، وسيتم تحويل وديعة الضمان من الحساب المرتبط بالضمان إلى حسابك التجاري القابل للتشغيل.',
    },
    applyCompany: 'تقديم طلب تاجر',
    applyCompanyDesc: 'كن تاجرًا معتمدًا واستفد من امتيازات التداول الإضافية',
    serviceList: [
      {
        title: 'ضمان الأمان',
        desc: 'الحفاظ على سرية معلوماتك كتاجر و عدم الكشف عنها بإي حال من الأحوال',
      },
      {
        title: 'نشر الإعلانات',
        desc: 'التجار مسموح لهم بنشر الإعلانات بحرية، مما يجعل عمليات الشراء والبيع أكثر مرونة وسهولة',
      },
      {
        title: 'علامة حصرية',
        desc: 'ستظهر علامة "V" بعد اسم التاجر حصريا لتعزيز ثقة العملاء في عمليات التداول',
      },
      {
        title: 'خدمات فردية',
        desc: 'سنقدم خدمة فردية وحصرية لكل تاجر',
      },
    ],
    congratulate: 'تهانينا، تمت الموافقة على طلبك، أصبحت تاجرًا معتمدًا',
    congratulateSuper: 'تهانينا، تمت الموافقة على طلبك، أصبحت تاجرًا معتمدًا سوبر',
    applyBtn: 'قدم الطلب الآن',
    applyBtnSuper: 'قدم طلب تاجر معتمد سوبر',
    relieve: 'إلغاء التوثيق',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    agree: 'أوافق على',
    agreePolicy: 'اتفاقية التاجر المعتمد',
    relieveing: 'جارٍ الإلغاء',
    dialogDesc: 'بمجرد إلغاء التوثيق، لن تتمكن من نشر الإعلانات. هل أنت متأكد من إلغاء التوثيق؟',
    stepProgress: [
      {
        text: 'شروط التقديم',
        status: 0,
      },
      {
        text: 'قيد المراجعة',
        status: 1,
      },
      {
        text: 'مكتمل',
        status: 3,
      },
    ],
    applyRegion: {
      options: [
        'الموافقة على تجميد',
        'كضمان تاجر',
      ],
      applyBtn: 'تقديم الطلب',
      applingBtn: 'جارٍ المراجعة',
      appliedBtn: 'صحفة التداول',
      cancelBtn: 'إلغاء الطلب',
      focus: 'نصائح هامة',
      focusContent: 'يجب أن يصبح التاجر  لنشر إعلانات في منطقة التداول بالكميات الكبيرة. التاجر يجب أن يكون لديه كفاءة عالية في التداول، وسمعة جيدة، وموافقة على دفع وديعة ضخمة لطلب تاجرًا معتمدًا سوبر',
      focusContentSuper: 'باستوفاء التاجر للمعايير التي تتضمن فعالية عالية في التداول وسمعة طيبة والموافقة على دفع وديعة ضخمة، يمكنه التقديم ليصبح تاجرًا معتمدًا سوبر.',
    },
    company: {
      head: {
        title: 'كيف تصبح تاجرًا؟',
        desc: 'يرجى اتباع الخطوات التالية لاستيفاء شروط الطلب',
        titleAppling: 'قيد المراجعة، يرجى الانتظار ',
        titleApplied: 'تهانينا، أصبحت تاجرًا معتمدًا',
        descApplied: 'يمكنك الاستفادة من امتيازات التداول التالية',
      },
      unApply: {
        stepOne: {
          title: 'الخطوة الأولى - تقديم طلبك',
          desc: [
            'لتصبح تاجر معتمد على منصة مال Mal.io، يرجى اتباع الخطوات التالية:',
            '1.قم بملء',
            ' استمارة الطلب ',
            '',
            "2. بعد إكمال الاستمارة وإرسالها، انقر فوق زر 'تقديم الطلب' الموجود في هذه الصفحة.<br/>3. تأكيد تجميد مبلغ 100 USDT كضمان<br />4. بمجرد تقديم الطلب بنجاح، يمكنك بدء نشر إعلاناتك في منطقة تداول P2P<br />نحن متواجدين في إي وقت لمساعدتك لاتتردد في التواصل بخدمة عملاء منصة مال Mal.io",
          ],
        },
        stepTwo: {
          title: 'الخطوة الثانية - مراجعة طلبك',
          desc: [
            'سنُراجع طلبك كتاجر في مدة لاتتجاوز 24 ساعة. شكرًا لك',
          ],
        },
        stepThree: {
          title: 'الخطوة الثالثة - تقديم الطلب',
          desc: [
            'بعد إرسال البريد الإلكتروني، يُرجى النقر على زر "تأكيد الطلب" على هذه الصفحة وتقديم الطلب. ويجب أن توافق على تجميد المبلغ',
            'كتاجر مضمون. بعد تقديم الطلب بنجاح، يمكنك نشر الإعلانات في منطقة التداول العادية',
          ],
        },
        stepFour: {
          title: 'الخطوة الرابعة - مراجعة المستندات',
          desc: [
            'سنقوم بمراجعة مستندات طلبك كتاجر خلال مدة لا تتجاوز 3 أيام عمل. يُرجى البقاء على اتصال وسنقوم بالتواصل معك بشكل مباشر',
          ],
        },
      },
      applying: {
        desc: '1. تم تقديم الطلب بنجاح، يتم حالياً مراجعة مستنداتك.<br/><br/>2. تم تجميد الضمان الخاص بك.<br/><br/>3. لقد قدمت الطلب، إذا كانت المعلومات المقدمة صحيحة، سيقوم فريق العمل بمراجعة طلبك خلال 3 أيام عمل',
      },
      applied: {
        desc: ' 1. التجار يمكنهم نشر الإعلانات بحرية لجعل عمليات الشراء والبيع أكثر مرونة وسهولة.<br/><br/>2. سيتم عرض شارة "V" الخاصة بالتاجر بعد اسمه لزيادة الثقة في أوجه الصفقة.<br/><br/>3. سنقدم خدمة فردية وحصرية للتجار من خلال تقديم خدمة عملاء شخص إلى شخص.',
      },
    },
    companySuper: {
      head: {
        title: 'كيف تصبح تاجرًا معتمدًا سوبر؟',
        desc: 'يرجى اتباع الخطوات التالية لاستيفاء شروط الطلب',
        titleAppling: 'قيد المراجعة، يرجى الانتظار',
        titleApplied: 'تهانينا، أصبحت تاجرًا معتمدًا سوبر',
        descApplied: 'يمكنك الاستفادة من امتيازات التداول التالية',
      },
      unApply: {
        stepOne: {
          title: 'الخطوة الأولى - تقديم الطلب',
          desc: [
            'يرجى النقر على زر "تقديم طلب تاجرًا" على هذه الصفحة والموافقة على تجميد المبلغ',
            'كتاجر مضمون  لترقية لتصبح تاجرًا معتمدًا سوبر. بعد تقديم الطلب بنجاح، يمكنك نشر إعلانات معاملات كبيرة.',
          ],
        },
        stepTwo: {
          title: 'الخطوة الثانية: المراجعة',
          desc: [
            'سنقوم بمراجعة طلبك خلال مدة لا تتجاوز 3 أيام عمل. يُرجى البقاء على اتصال وسنقوم بالتواصل معك بشكل مباشر.',
          ],
        },
      },
      applying: {
        desc: [
          '1. تم تقديم الطلب بنجاح، يتم حالياً مراجعة مستنداتك.',
          '2. لقد تم تجميد ',
          'الضمان (الوديعة) الخاص بك',
          ' 3. لقد قدمت الطلب، إذا كانت المعلومات المقدمة صحيحة، سيقوم فريق العمل بمراجعة طلبك خلال 3 أيام عمل.',
        ],
      },
      applied: {
        desc: ' 1. يمكن للتجار المعتمدين سوبر  نشر الإعلانات بحرية  في أي منطقة ، لجعل عمليات الشراء والبيع أكثر مرونة وسهولة.<br/><br/>2. سيتم عرض شارة "V" الخاصة بالتاجر بعد اسمه لزيادة الثقة في أوجه الصفقة.<br/><br/>3. سنقدم خدمة فردية وحصرية للتجار من خلال تقديم خدمة عملاء شخص إلى شخص.',
      },
    },
    unEnough: 'الرصيد المتاح في حساب العملات النقدية غير كافي.',
  },
  login: {
    WelcomeToLogin: 'مرحبًا بالدخول',
    NotRegisteredUsersYet: 'لست مستخدمًا مسجلاً بعد',
    goRegister: 'التسجيل الآن',
    phoneOrEmail: 'الحساب',
    formatIncorrect: 'تنسيق غير صحيح',
    password: 'كلمة المرور',
    passwordError: 'الرجاء إدخال 8-20 حرفًا، يجب أن تتضمن أرقامًا + أحرفًا',
    VerificationMode: 'طريقة التحقق',
    AuthenticationMethod: 'يرجى اختيار طريقة المصادقة',
    ForgetPassword: 'نسيت كلمة المرور',
    login: 'تسجيل الدخول',
    SecurityVerification: 'التحقق من الأمان',
    MailboxValidation: 'التحقق من البريد الإلكتروني',
    MobilePhoneVerification: 'التحقق عبر الهاتف المحمول',
    GoogleAuthenticator: 'المصادقة عبر Google',
    googleCodeError: 'الرجاء إدخال رمز Google المكون من 6 أرقام',
    phoneCodeError: 'الرجاء إدخال رمز الهاتف المكون من 6 أرقام',
    emailCodeError: 'الرجاء إدخال رمز البريد الإلكتروني المكون من 6 أرقام',
    codeError: 'الرجاء إدخال رمز التحقق المكون من 6 أرقام',
    googleCode: 'رمز Google',
    phoneCode: 'رمز الهاتف',
    emailCode: 'رمز البريد الإلكتروني',
    code: 'رمز التحقق',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    phoneSendSuccess: 'تم إرسال الرسالة النصية القصيرة، يرجى التحقق',
    emailSendSuccess: 'تم إرسال البريد الإلكتروني، يرجى التحقق',
    loginPrompt: '(لا حاجة لإضافة رمز الدولة عند تسجيل الدخول بالهاتف)',
  },
  register: {
    phoneRegister: 'التسجيل عبر رقم الهاتف',
    emailRegister: 'التسجيل عبر البريد الإلكتروني',
    WelcomeToRegister: 'مرحبًا بالتسجيل',
    AlreadyAregisteredUser: 'مستخدم مسجل بالفعل',
    logInImmediately: 'تسجيل الدخول الآن',
    location: 'الموقع',
    PleaseSelectAcountry: 'يرجى تحديد دولة',
    password: 'كلمة المرور',
    passwordError: '8-20 حرفًا، يجب أن تحتوي على أحرف وأرقام، الرموز تشمل .~!@#$%^&*()',
    confirmPassword: 'تأكيد كلمة المرور',
    confirmPasswordError: 'كلمتا المرور غير متطابقتين',
    InvitationCodeError: 'الرجاء إدخال رمز الدعوة',
    IHaveReadAndAgreed: 'لقد قرأت ووافقت على',
    UserAgreement: 'اتفاقية المستخدم',
    UserAgreementLink: 'https://exchange.zendesk.com/hc/ar/articles',
    register: 'تسجيل',
    phone: 'رقم الهاتف',
    phoneError: 'تنسيق رقم الهاتف غير صحيح',
    phoneCode: 'رمز التحقق عبر الهاتف',
    phoneCodeError: 'الرجاء إدخال رمز الهاتف المكون من 6 أرقام',
    email: 'البريد الإلكتروني',
    emailError: 'تنسيق البريد الإلكتروني غير صحيح',
    emailCode: 'رمز البريد الإلكتروني',
    emailCodeError: 'الرجاء إدخال رمز البريد الإلكتروني المكون من 6 أرقام',
    InvitationCodeOptional: 'رمز الدعوة (اختياري)',
    InvitationCodeIsRequired: 'رمز الدعوة',
    registerSuccessQLogin: 'تم التسجيل بنجاح، وتسجيل الدخول',
    scrollCode: 'يرجى التمرير للتحقق من الأمان قبل الحصول على رمز التحقق',
    phoneSendSuccess: 'تم إرسال الرسالة النصية القصيرة، يرجى التحقق',
    emailSendSuccess: 'تم إرسال البريد الإلكتروني، يرجى التحقق',
    registerSuccess: 'تم التسجيل بنجاح، يرجى تسجيل الدخول',
    passwordStrength: 'قوة كلمة المرور',
    weak: 'ضعيفة',
    medium: 'متوسطة',
    strong: 'قوية',
    strengthCondition_1: '8-20 حرفًا تحتوي على أرقام',
    strengthCondition_2: 'أحرف كبيرة وصغيرة',
    strengthCondition_3: 'رموز خاصة',
  },
  resetPass: {
    googleCode: 'رمز Google',
    googleError: 'الرجاء إدخال رمز Google المكون من 6 أرقام',
    IDCode: 'رقم الهوية',
    IDError: 'الرجاء إدخال رقم الهوية',
    next: 'التالي',
    submit: 'إرسال',
    phoneReset: 'استعادة عبر الهاتف',
    emailReset: 'استعادة عبر البريد الإلكتروني',
    ResetLoginPassword: 'إعادة تعيين كلمة مرور تسجيل الدخول',
    ResetLoginPasswordError: 'ممنوع السحب خلال 48 ساعة من إعادة تعيين كلمة مرور تسجيل الدخول',
    password: 'كلمة مرور تسجيل الدخول الجديدة',
    passwordError: 'الرجاء إدخال 8-20 حرفًا، يجب أن تتضمن أرقامًا + أحرفًا ',
    confrimPassWord: 'تأكيد كلمة مرور الدخول',
    confrimPassWordError: 'كلمتا المرور غير متطابقتين',
    phone: 'رقم الهاتف',
    phoneError: 'تنسيق رقم الهاتف غير صحيح',
    phoneCode: 'رمز التحقق عبر الهاتف',
    phoneCodeError: 'الرجاء إدخال رمز الهاتف المكون من 6 أرقام',
    email: 'البريد الإلكتروني',
    emailError: 'تنسيق البريد الإلكتروني غير صحيح',
    emailCode: 'رمز البريد الإلكتروني',
    emailCodeError: 'الرجاء إدخال رمز البريد الإلكتروني المكون من 6 أرقام',
    resetSuccess: 'تمت إعادة تعيين كلمة المرور بنجاح، يرجى تسجيل الدخول',
    phoneSendSuccess: 'تم إرسال الرسالة النصية القصيرة، يرجى التحقق',
    emailSendSuccess: 'تم إرسال البريد الإلكتروني، يرجى التحقق',
  },
  assets: {
    branchName: 'اسم الشبكة',
    hideMinAssets: 'إخفاء الأصول الصغيرة',
    suspend: 'إيقاف مؤقت',
    withdrawStop: 'السحب معلق مؤقتًا',
    depositStop: 'الإيداع معلق مؤقتًا',
    b2c: {
      otcShow: {
        header: 'التداول بالعملات النقدية',
        fiatTitle: 'تنبيه إعدادات التداول بالعملات النقدية',
        leaglTenderSet: 'إعدادات العملات النقدية',
        fiatdealTitle: 'التداول بالعملات النقدية',
        goHall: 'صفحة التداول',
        unEnough: 'الرصيد المتاح في حساب العملات النقدية غير كافي.',
        otcAccount: 'حساب العملات النقدية',
        lagel: 'العملة النقدية',
        otcOrder: 'طلبات العملات النقدية',
        otcTradeWarning: 'من أجل ضمان أمان الأموال، سيتم تأمين الأصول التي تم شراؤها لمدة 24 ساعة قبل أن يتم دعم عمليات السحب وبيع العملات القانونية وغيرها من عمليات السحب. وخلال هذه الفترة، لن تؤثر هذه العمليات على التداول وغيرها من الأعمال.',
      },
      lagel: 'العملة النقدية',
      allName: 'الاسم الكامل',
      recrgeTitle: 'حساب الإيداع',
      rechargeSum: 'مبلغ الإيداع',
      rechargeMin: 'ملاحظة: الإيداع لا يجب أن يكون أقل من',
      voucherTit: 'إيصال التحويل',
      voucherWarn: 'بعد إتمام عملية التحويل، يُرجى تحميل سجلك الخاص بالتحويل.',
      voucherCli: 'رفع إيصال التحويل الخاص بك لإكمال العملية',
      bankName: 'اسم البنك',
      bankSub: 'فرع البنك',
      cardNo: 'رقم البطاقة',
      name: 'المستفيد',
      remark: 'ملاحظة التحويل',
      withdrawMin: 'الحد الأدنى لسحب الواحد',
      withdrawMax: 'الحد الأقصى لسحب الواحد',
      withdrawDay: 'المبلغ المسموح بسحبه اليوم',
      withdrawAddress: 'حساب سحب العملات',
      fee: 'الرسوم',
      arrivalAccount: 'المبلغ المستلم',
      withdrawMinWarn: 'الحد الأدنى لسحب الواحد لا يجب أن يكون أقل من',
      withdrawMaxWarn: 'الحد الأقصى لسحب الواحد لا يجب أن يكون أعلى من',
      withdrawDayWarn: 'المبلغ المسموح بسحبه اليوم',
      withdrawHaveWarn: 'الرصيد المتاح',
      addressMent: 'إدارة حساب السحب',
      addressAddTit: 'إضافة حساب سحب العملات',
      addressSetTit: 'تعديل حساب سحب العملات',
      addressListTit: 'قائمة الحسابات',
      warning: 'تنبيه',
      deleteWarn: 'تأكيد الحذف؟',
      payType: 'طريقة الدفع',
      address: 'الحساب',
      addressUserName: 'المستفيد',
      bankCard: 'بطاقة البنك',
      set: 'تعديل',
      firstWay: 'طريقة الاستلام',
      country: 'جهة الافتتاح (البنك)',
      countrySub: 'جهة الافتتاح الفرعية',
      countryNo: 'رقم الحساب البنكي',
      submit: 'ارسال',
      b2cRecrgeHisList1: 'عدد الطلبات',
      b2cRecrgeHisList2: 'المبلغ الفعلي المستلم',
      b2cRecrgeHisList3: 'وقت المعالجة',
      seePz: 'عرض الإيصال',
      b2cWithdrawHisList1: 'المبلغ المستلم',
    },
    krw: {
      rechargeMin: 'الحد الأدنى للشحن',
      rechargeAccount: 'حساب الشحن البنكي',
      rechargeUserName: 'اسم صاحب الحساب البنكي',
      rechargeBankName: 'اسم البنك',
      rechargeBankAccount: 'رقم الحساب البنكي',
      rechargeSum: 'مبلغ الشحن',
      rechargeConfrim: 'تأكيد الشحن',
      rechargeTo: 'الشحن إلى الحساب المحدد',
      rechargeText: 'محتوى ملاحظة التحويل',
      copySuccess: 'تم النسخ بنجاح',
      rechargeList1: 'وقت الطلب',
      rechargeList2: 'وقت القيد في الحساب',
      rechargeList3: 'العملة',
      rechargeList4: 'مبلغ الشحن',
      rechargeList5: 'المبلغ المقيد',
      rechargeList6: 'حساب المنصة',
      rechargeList7: 'الحالة',
      rechargeListError: 'لم يقيد بعد',
      withdrawAccount: 'حساب السحب البنكي',
      withdrawUserName: 'اسم صاحب الحساب البنكي',
      withdrawBankName: 'اسم البنك',
      withdrawBankAccount: 'رقم الحساب البنكي',
      withdrawFee: 'رسوم السحب',
      withdrawNum: 'المبلغ المستلم',
      withdrawAuth1: 'التحقق بالهاتف',
      withdrawAuth2: 'المصادقة عبر OTP',
      withdrawAuth3: 'ربط البطاقة البنكية',
      withdrawList1: 'وقت الطلب',
      withdrawList2: 'وقت الاستلام',
      withdrawList3: 'العملة',
      withdrawList4: 'مبلغ السحب',
      withdrawList5: 'الرسوم',
      withdrawList6: 'حساب المستخدم البنكي',
      withdrawList7: 'الحالة',
      withdrawListError: 'لم يستلم بعد',
    },
    index: {
      title: 'مركز الأصول',
      overview: 'نظرة عامة',
      exchangeAccount: 'حساب التداول',
      coExchangeAccount: 'الحساب الرئيسي',
      addressMent: 'إدارة العناوين',
      flowingWater: 'تدفقات رأس المال',
      otcAccount: 'حساب العملات القانونية',
      otcFlowingWater: 'تدفقات رأس المال',
      coAccount: 'حساب العقود',
      leverage: 'حساب الرافعة',
      bibaoAccount: 'حساب العملة الاحتياطية',
      detail: 'عرض التفاصيل',
    },
    leverageAccount: {
      find: 'البحث عن حساب رافعة',
      list1: 'حساب الرافعة',
      list2: 'إجمالي الأصول',
      list3: 'متاح',
      list4: 'مجمد',
      list5: 'مقترض',
      list6: 'سعر التصفية',
      list7: 'معدل المخاطر',
      list8: 'العمليات',
      transfer: 'تحويل',
      ToLoan: 'اقتراض',
    },
    leverageToLoan: {
      typeText1: 'المبلغ الأصلي',
      typeText2: 'الفائدة',
      typeText3: 'المبلغ الأصلي + الفائدة',
      title: 'اقتراض',
      can: 'متاح',
      transfer: 'تحويل إلى',
      warning: 'عندما يكون معدل المخاطر ≤110٪، سيتم تصفية الحساب لسداد الأموال المقترضة',
      max: 'الحد الأقصى',
      borrowed: 'مقترض',
      rate: 'سعر الفائدة',
      rateMark: 'سعر الفائدة هو النسبة التي تحصل عليها المنصة كفائدة عند طلب الاقتراض، وتحتسب الفائدة كل 24 ساعة',
      number: 'كمية الاقتراض',
      ToLoan: 'اقتراض',
      listTitle: 'سجل الاقتراض الأخير',
      list1: 'وقت الطلب',
      list2: 'حساب الرافعة',
      list3: 'العملة',
      list4: 'الكمية',
      list5: 'سعر الفائدة',
      list6: 'الفائدة غير المسددة',
      list7: 'الكمية غير المسددة',
      list8: 'العمليات',
      canToLoan: 'يمكن اقتراضه',
      inputError1: 'لا يجوز أن تتجاوز كمية الاقتراض الكمية القابلة للاقتراض',
      inputError2: 'لا يجوز أن تقل كمية الاقتراض عن',
      repayment: 'سداد',
    },
    leverageTransfer: {
      title: 'تحويل الأموال',
      leverageAccount: 'حساب الرافعة',
    },
    leverageRepayment: {
      title: 'سداد',
      symbol: 'حساب الرافعة',
      coin: 'عملة السداد',
      Surplus: 'الكمية المستحقة',
      sum: 'كمية الاقتراض',
      rate: 'الفائدة',
      RepaymentNum: 'كمية السداد',
      error1: 'لا يجوز أن تقل كمية السداد عن',
      error2: 'لا يجوز أن تتجاوز كمية السداد الكمية المتاحة',
      error3: 'لا يجوز أن تتجاوز كمية السداد الكمية المستحقة',
      can: 'متاح',
    },
    lerverageFlowingWater: {
      direction: 'الاتجاه',
      symbol: 'حساب الرافعة',
      allCoin: 'جميع حسابات الرافعة',
      directionAll: 'الكل',
      directionIn: 'داخل',
      directionOut: 'خارج',
      tab1: 'الاقتراض الحالي',
      tab2: 'الاقتراض السابق',
      tab3: 'سجل التحويل',
      tab1List1: 'وقت الطلب',
      tab1List2: 'حساب الرافعة',
      tab1List3: 'العملة',
      tab1List4: 'الكمية',
      tab1List5: 'سعر الفائدة',
      tab1List6: 'الفائدة غير المسددة',
      tab1List7: 'الكمية غير المسددة',
      tab1List8: 'العمليات',
      tab2List1: 'وقت الطلب',
      tab2List2: 'حساب الرافعة',
      tab2List3: 'العملة',
      tab2List4: 'الكمية',
      tab2List5: 'سعر الفائدة',
      tab2List6: 'الفائدة',
      tab2List7: 'الحالة',
      tab3List1: 'الوقت',
      tab3List2: 'حساب الرافعة',
      tab3List3: 'العملة',
      tab3List4: 'الكمية',
      tab3List5: 'الاتجاه',
      repayment: 'سداد',
      status1: 'اقتراض',
      status2: 'سداد جزئي',
      status3: 'تم السداد',
      status4: 'تصفية',
      status5: 'خرق',
      status6: 'انتهاء التصفية',
      status7: 'انتهاء الخرق',
    },
    exchangeAccount: {
      positionBalance: 'تثبيت التعدين',
      incomeLock: 'تثبيت الاستثمار',
      positionV2Amount: 'تثبيت الرمز',
      TotalAssets: 'إجمالي الأصول المكافئ',
      MyAssets: 'أصولي',
      ListOfFunds: 'قائمة الأموال',
      HideZeroAssets: 'إخفاء الحسابات صفر الأصول',
      SearchCurrency: 'البحث عن العملة',
      coin: 'العملة',
      lumpSum: 'الإجمالي',
      Available: 'متاح',
      freeze: 'مجمد',
      AssetFolding: 'طي الأصول',
      options: 'العمليات',
      other: 'أخرى',
      Recharge: 'شحن',
      withdraw: 'سحب',
      position: 'تثبيت',
      limit: 'حدود',
      trade: 'تداول',
    },
    addressMent: {
      pageText: 'يتطلب الشحن عنوان شحن وتسمية (ملاحظة) في نفس الوقت. التسمية هي سلسلة أرقام فريدة لضمان فرادة عنوان الشحن الخاص بك، وتظهر مع عنوان الشحن كزوج وتتوافق معه واحدة إلى واحدة. يرجى اتباع خطوات الشحن الصحيحة وإدخال المعلومات الكاملة عند السحب، وإلا قد يؤدي ذلك إلى فقدان العملات.',
      addAddress: 'إضافة عنوان سحب',
      coin: 'العملة',
      WithdrawalAddress: 'عنوان السحب',
      Remarks: 'ملاحظات العنوان',
      label: 'التسمية (ملاحظة)',
      add: 'إضافة',
      listCoin: 'العملة',
      listRemarks: 'الملاحظات',
      listAddress: 'العنوان',
      listOptions: 'العمليات',
      AddressList: 'قائمة العناوين',
      safetyWarning: 'تحذير أمني',
      safetyWarningError: 'من أجل أمان حسابك، يرجى تفعيل وسيلة التحقق الواحدة على الأقل',
      GotoOpen: 'الذهاب للتفعيل',
      safetyVerification: 'التحقق من السلامة',
      phoneCode: 'رمز الهاتف',
      phoneCodeError: 'يرجى إدخال رمز الهاتف المكون من 6 أرقام',
      googleCode: 'رمز Google',
      googleCodeError: 'يرجى إدخال رمز Google المكون من 6 أرقام',
      bindGoogle: 'ربط المصادقة عبر Google',
      bindPhone: 'ربط المصادقة عبر الهاتف',
      phoneSendSuccess: 'تم إرسال الرسالة القصيرة، يرجى التحقق',
      delete: 'حذف',
      notSupport: 'هذه العملة لا تدعم التداول حاليًا',
    },
    flowingWater: {
      coin: 'العملة',
      type: 'النوع',
      allCoin: 'كل العملات',
      RechargeRecord: 'سجل الشحن',
      WithdrawalsRecord: 'سجل السحب',
      OtherRecords: 'سجلات أخرى',
      RechargeTime: 'وقت الشحن',
      RechargeCoin: 'العملة',
      RechargeVolume: 'كمية الشحن',
      RechargeNumber: 'عدد مرات التأكيد',
      RechargeStatus: 'الحالة',
      withdrawTime: 'وقت السحب',
      withdrawAddress: 'عنوان السحب',
      withUser: 'المستخدم المصدر',
      rechargeAddress: 'عنوان الشحن',
      withdrawVolume: 'كمية السحب',
      withdrawFee: 'الرسوم',
      withdrawRemarks: 'ملاحظات',
      withdrawStatus: 'الحالة',
      withdrawOptions: 'العمليات',
      otherTime: 'الوقت',
      otherCoin: 'العملة',
      otherType: 'النوع',
      otherVolume: 'الكمية',
      otherStatus: 'الحالة',
      Cancel: 'إلغاء',
      label: 'التسمية',
      updataAt: 'وقت معالجة المحفظة',
      txid: 'معرف المعاملة على البلوكشين',
      type1: 'شحن خارجي',
      type2: 'تحويل داخلي',
    },
    recharge: {
      pageText: 'يتطلب الشحن عنوان شحن وتسمية (ملاحظة) في نفس الوقت. التسمية هي سلسلة أرقام فريدة لضمان فرادة عنوان الشحن الخاص بك، وتظهر مع عنوان الشحن كزوج وتتوافق معه واحدة إلى واحدة. يرجى اتباع خطوات الشحن الصحيحة وإدخال المعلومات الكاملة عند السحب، وإلا قد يؤدي ذلك إلى فقدان العملات.',
      rechargeWarning: 'يجب إدخال عنوان الشحن والتسمية عند الشحن، فهما المعرّف الفريد لحسابك، عدم الإدخال أو الإدخال الخاطئ سيؤدي إلى فقدان أصولك.',
      recharge: 'شحن',
      rechargeError: 'يرجى عدم الشحن إلى العنوان أعلاه أي أصول غير العملة المحددة، وإلا لن يمكن استرداد الأصول',
      minimumDepositAmount: 'الحد الأدنى للإيداع',
      depositcredited: 'تم إضافة الشحن إلى الرصيد',
      networkConfirmation: 'مرات تأكيد الشبكة',
      rechargeAddress: 'عنوان الشحن',
      label: 'التسمية (ملاحظة)',
      RecentRechargeRecord: 'أحدث سجلات الشحن',
      RechargeReminder: 'تذكير بالشحن',
      lumpSum: 'الإجمالي',
      Available: 'متاح',
      freeze: 'مجمد',
      RechargeTime: 'وقت الشحن',
      RechargeCoin: 'العملة',
      RechargeVolume: 'كمية الشحن',
      RechargeNumber: 'عدد مرات التأكيد',
      RechargeStatus: 'الحالة',
      copyAddress: 'تم نسخ العنوان بنجاح',
      copyLabel: 'تم نسخ التسمية بنجاح',
      notSupport: 'هذه العملة لا تدعم الشحن حاليًا',
    },
    withdraw: {
      pageText: 'يتطلب الشحن عنوان شحن وتسمية (ملاحظة) في نفس الوقت. التسمية هي سلسلة أرقام فريدة لضمان فرادة عنوان الشحن الخاص بك، وتظهر مع عنوان الشحن كزوج وتتوافق معه واحدة إلى واحدة. يرجى اتباع خطوات الشحن الصحيحة وإدخال المعلومات الكاملة عند السحب، وإلا قد يؤدي ذلك إلى فقدان العملات.',
      withdraw: 'سحب',
      lumpSum: 'الإجمالي',
      Available: 'متاح',
      freeze: 'مجمد',
      MinimumCoinLimit: 'الحد الأدنى للسحب',
      MaximumCoinLimit: 'الحد الأقصى للسحب',
      dayMaximumCoinLimit: 'المتبقي للسحب اليومي',
      CoinAddress: 'عنوان السحب',
      label: 'التسمية (ملاحظة)',
      NumberOfCoins: 'كمية السحب',
      fee: 'الرسوم',
      feeError: 'يرجى إدخال رسوم صحيحة',
      allWithdraw: 'سحب الكل',
      buttonWithdraw: 'سحب',
      addAddrss: 'إضافة عنوان سحب',
      RecentWithdrawalRecords: 'أحدث سجلات السحب',
      safetyWarning: 'تحذير أمني',
      safetyWarningError: 'من أجل سلامة الحساب الخاص بك ، يرجى فتح واحد على الأقل طريقة التوثيق .',
      enforceGoogleAuth: 'من أجل أمان حسابك، يرجى تفعيل التحقق الأمني',
      GotoOpen: 'الذهاب للتفعيل',
      safetyVerification: 'التحقق من السلامة',
      phoneCode: 'رمز الهاتف',
      phoneCodeError: 'يرجى إدخال رمز الهاتف المكون من 6 أرقام',
      googleCode: 'رمز Google',
      googleCodeError: 'يرجى إدخال رمز Google المكون من 6 أرقام',
      bindGoogle: 'ربط المصادقة عبر Google',
      bindPhone: 'ربط المصادقة عبر الهاتف',
      withdrawTime: 'وقت السحب',
      withdrawAddress: 'عنوان السحب',
      withdrawVolume: 'كمية السحب',
      withdrawFee: 'الرسوم',
      withdrawRemarks: 'ملاحظات',
      withdrawStatus: 'الحالة',
      withdrawOptions: 'العمليات',
      NumberOfCoinsError: 'يرجى إدخال كمية السحب',
      NumberOfCoinsError2: 'يجب أن تتجاوز كمية السحب الرسوم',
      NumberOfCoinsError3: 'لا يمكن أن تتجاوز كمية السحب الرصيد المتاح',
      NumberOfCoinsError4: 'يجب أن تتجاوز (كمية السحب - الرسوم) الحد الأدنى للسحب وأن تقل عن الحد الأقصى للسحب',
      NumberOfCoinsError5: 'يجب أن تقل (كمية السحب - الرسوم) عن الحد المتبقي للسحب اليومي',
      phoneSendSuccess: 'تم إرسال الرسالة القصيرة، يرجى التحقق',
      range: 'النطاق',
      account: 'حساب الطرف الآخر (رقم الهاتف / البريد الإلكتروني / المعرف)',
      innerList: 'سجل التحويل المباشر',
      transferTime: 'وقت التحويل',
      transferNumber: 'كمية التحويل',
      sideAccount: 'حساب الطرف الآخر',
      innerTranfer: 'تحويل مباشر داخلي',
      transfer: 'تحويل',
      notSupport: 'هذه العملة لا تدعم السحب حاليًا',
    },
    otcAccount: {
      TotalAssets: 'إجمالي الأصول المكافئ',
      ListOfFunds: 'قائمة الأموال',
      HideZeroAssets: 'إخفاء الحسابات صفر الأصول',
      SearchCurrency: 'البحث عن العملة',
      CapitalTransfer: 'تحويل رأس المال',
      coin: 'العملة',
      Available: 'متاح',
      freeze: 'مجمد',
      options: 'العمليات',
      from: 'من',
      to: 'تحويل إلى',
      exchangeAccount: 'حساب التداول',
      otcAccount: 'حساب العملات القانونية',
      all: 'الكل',
      volume: 'كمية التحويل',
      volumeError: 'غير كافٍ',
      can: 'يمكن تحويل',
      other: 'آخر',
      optionCapitalTransfer: 'تحويل رأس المال',
    },
    otcFlowingWater: {
      title: 'تدفقات رأس المال',
      type: 'النوع',
      coin: 'العملة',
      all: 'الكل',
      allCoin: 'كل العملات',
      inOtc: 'داخل للعملات القانونية',
      outOtc: 'خارج من العملات القانونية',
      listTime: 'الوقت',
      listCoin: 'العملة',
      listType: 'النوع',
      listVolume: 'الكمية',
    },
    coAccount: {
      quota: 'رصيد الحساب',
      transfer: 'تحويل الأموال',
      totel: 'الرصيد المتاح',
      accountRight: 'حقوق الحساب',
      orderMargin: 'هامش الأوامر',
      positionMargin: 'هامش المراكز',
      unrealisedAmount: 'الربح/الخسارة غير المحققة',
      listTitle: 'العقود غير المغلقة',
      useMarginRate: 'نسبة الهامش المستخدم',
      coAccount: 'حساب العقود',
      list1: 'العقد',
      list2: 'عدد المراكز (عقد)',
      list3: 'الربح/الخسارة المحققة',
      list4: 'الربح/الخسارة غير المحققة',
      list5: 'العمليات',
      type1: 'دائم',
      type2: 'أسبوعي',
      type3: 'الأسبوع التالي',
      type4: 'شهري',
      type5: 'ربع سنوي',
    },
    coFlowingWater: {
      list1: 'الوقت',
      list2: 'النوع',
      list3: 'المبلغ',
      list4: 'العقد',
      list5: 'حساب العقود',
    },
    bibaoAccount: {
      bibaoAccount: 'حساب العملة الاحتياطية',
      coin: 'العملة',
      lumpSum: 'الإجمالي',
      quota: 'الرصيد',
      bibao: 'العملة الاحتياطية',
      opera: 'العمليات',
      transfer: 'تحويل إلى',
      detail: 'التفاصيل',
      bibaoDetail: 'تفاصيل العملة الاحتياطية',
      transferNum: 'كمية التحويل',
      freed: 'إطلاق',
      startTime: 'وقت البدء',
      endTime: 'وقت الانتهاء',
      status: 'الحالة',
    },
  },
  order: {
    otcOrder: {
      haveCancel: 'عرض الطلبات الملغاة',
      coin: 'عملة',
      allCoin: 'الكل',
      nowOrder: 'طلبات مفتوحة',
      hisOrder: 'سجل الطلبات',
      all: 'الكل',
      buy: 'شراء',
      sell: 'بيع',
      nowOrderId: 'رقم الطلب',
      nowOrderType: 'العملية',
      nowOrderCoin: 'العملة',
      nowOrderPirce: 'السعر',
      nowOrderVolume: 'الكمية',
      service: 'الرسوم',
      nowOrderTotol: 'مبلغ العملية',
      nowOrderStatus: 'الحالة',
      nowOrderUser: 'المشتري / البائع',
      hisOrderId: 'رقم',
      hisOrderType: 'العملية',
      hisOrderCoin: 'العملة',
      hisOrderPirce: 'السعر',
      hisOrderVolume: 'الكمية',
      hisOrderTotol: 'مبلغ العملية',
      hisOrderStatus: 'الحالة',
      hisOrderUser: 'المشتري / البائع',
    },
  },
  otcRelease: {
    title: 'نشر الإعلان',
    text1: ' انشر إعلانك الخاص للتداول متكرر ، للشراء/البيع مرة واحدة، نقترح أن تستخدم قائمة الشراء/البيع للتداول',
    text2: 'تأكد من إن رصيدك كاف إذا كنت تريد نشر إعلان البيع',
    text3: 'التجار الذين ينشروا إعلانات التداول يحتاجون إلى دفع رسوم لكل معاملة مكتملة، الرسوم الخاصة تعتمد على الحالة المعاملة',
    text4: 'يتم تسعير العملات وفقًا لسعر السوق، يمكن تغيير سعر المعاملة بمرونة وفقًا لظروف السوق، في حين أن السعر الثابت لا يمكن تغييره',
    text5: 'يُقترح أن يتم كل التواصل على منصة مال لتجنب المخاطر غير الضرورية',
    type: 'نوع الإعلان',
    buy: 'شراء',
    sell: 'بيع',
    currency: 'العملة',
    currencyError: 'اختر نوع العملة',
    countryType: 'بلد/منطقة',
    countryError: 'الرجاء اختيار منطقة/بلد خدمة الطلبات',
    volume: 'الكمية',
    Surplus: 'رصيدك',
    CurrentUnitPrice: 'السعر الحالي',
    ReferenceWebSite: 'موقع المرجع للسعر',
    PricingMethod: 'طريقة التسعير',
    PricingMethodError: 'اختر نوع العملة',
    CustomPrice: 'السعر المخصص',
    TotalSum: 'المبلغ الإجمالي',
    MinimumQuota: 'الحد الأدنى',
    MaximumQuota: 'الحد الأقصى',
    min: 'دقيقة',
    TimeLimitForPayment: 'الوقت المحدد للدفع',
    MinimumNumber: 'الحد الأدنى للمعاملة',
    frequency: 'مرة',
    FailureTime: 'وقت الانتهاء',
    FailureTimeError: 'اختر وقت الانتهاء',
    PaymentMethod: 'طريقة الدفع',
    PaymentMethodWarning: 'يمكن اختيار ما يصل إلى 3 طرق دفع',
    Receivables: 'طريقة الاستلام',
    ReceivablesWarning: 'يمكن اختيار طرق استلام متعددة',
    PaymentError: 'لا يوجد طريقة دفع متعددة. يرجى زيارة المركز الشخصي لإعدادها',
    AutomaticRecovery: 'الرد التلقائي (اختياري)',
    AdvertisingMessage: 'رسالة الإعلان (اختياري)',
    submit: 'نشر الإعلان',
    Reminder: 'ملاحظة',
    AnotherOne: 'إعلان آخر',
    goHall: 'العودة إلى قائمة الإعلانات',
    success: 'تم نشر الإعلان بنجاح',
    SafetyTips: 'نصائح السلامة',
    MarketPrice: 'سعر السوق (الزيادة)',
    Custom: 'مخصص',
    PleaseEnterQuantity: 'الرجاء إدخال الحجم',
    availableBalance: 'الرصيد غير كاف ',
    minPriceError1: 'لا يمكن أن يتجاوز الحد الأدنى الإجمالي',
    minPriceError2: 'يجب أن يكون الحد الأدنى أقل من الحد الأقصى',
    maxPriceError1: 'لا يمكن أن يتجاوز الحد الأقصى الإجمالي',
    maxPriceError2: 'يجب أن يكون الحد الأقصى أكبر من الحد الأدنى',
    paymentTimeLimit: 'أدخل الحد الزمني للدفع',
    paymentTimeError: 'يجب أن يكون وقت الدفع بين 10-20 دقيقة',
    jurisdictionTitle: 'أكمل التحقق من الهوية، وإعداد الأسم المستعار ونشر إعلان',
    jurisdictionTitle2: 'أكمل التحقق من الهوية وضع الكنية والتقدم ليصبح تاجر لنشر إعلان',
    authentication: 'التحقق من الهوية',
    DeCertification: 'توثيق',
    SetNickname: 'تعين اسم مستعار',
    ToSetUp: 'الاعدادات',
    ApplicationMerchant: 'تقديم طلب تاجر',
    ToApply: 'تقديم',
    threePayment: 'يمكن اختيار ما يصل إلى 3 طرق دفع',
    day: 'يوم',
    higher: 'أعلى من سعر السوق المرجعي',
    lower: 'أقل من سعر السوق المرجعي',
    precent: 'معدل الزيادة ',
    des: 'يشير إلى أسعار صرف العملات الرئيسية، يتم تحديثها بانتظام',
    precentWay: 'اتجاه الزيادة',
    precentError: 'لا يمكن أن يتجاوز معدل الزيادة 50.00%',
  },
  otcTrade: {
    warning: 'تتم قفل الأصول المشتراة لمدة 24 ساعة لضمان الأمان؛ يتم إيقاف السحب ومبيعات العملة النقدية. التداول لا يتأثر',
    inLine: 'متصل',
    outLine: 'غير متصل',
    TransactionTimes: 'عدد المعاملات',
    CreditDegree: 'التقييم',
    his: 'تاريخ المعاملات (ما يعادل BTC)',
    price: 'السعر',
    volume: 'الكمية',
    TradingLimit: 'حد التداول',
    TimeLimitPayment: 'وقت الدفع',
    MerchantRemarks: 'ملاحظات التاجر',
    min: 'دقيقة',
    closeTitle: 'إغلاق الإعلان',
    closeWarning: 'إغلاق الإعلان يتوقف عن التداول، هل أنت متأكد من الإغلاق؟',
    goHall: 'الرئيسية',
    close: 'إغلاق',
    PurchaseAmount: 'كمية الشراء',
    AmountSale: 'كمية البيع',
    all: 'الكل',
    pass: 'كلمة مرور الاصول',
    passError: 'أدخل من 8 إلى 20 حرفًا، بما في ذلك الأرقام والحروف',
    ImmediateSale: 'بيع الآن',
    ImmediatePurchase: 'شراء الآن',
    CountDown: 'العد التنازلي',
    numberError: 'الطلب يتجاوز الحجم المتاح',
    numberMinError: 'كمية التبادل أقل من حد التداول الأدنى',
    numberMaxError: 'كمية التبادل أعلى من حد التداول الأقصى',
    OrderAmount: 'كمية الطلب',
    ScopeOrderAmount: 'نطاق كمية الطلب',
    QuantityInExchange: 'حجم التبادل',
    use: 'ب ',
    sell: 'بيع',
    buy: 'شراء',
    TransactionMode: 'طريقة التداول',
    payment: 'طريقة الدفع',
    Receivables: 'طريقة الاستلام',
    none: 'لا يوجد',
  },
  otcDetailOrder: {
    noPaymentErr: 'الرجاء اختيار طريقة الدفع',
    addPaymentErr: 'يرجى إضافة طريقة الدفع',
    goPay: 'دفع الآن',
    CancellationOrder: 'إلغاء الطلب',
    WaitingPayment: 'في انتظار الدفع',
    WaitingPuttingMoney: 'في انتظار البائع لتحرير العملة',
    ConfirmReleaseMoney: 'تحرير العملة',
    SubmitAcomplaint: 'تقديم شكوى',
    goHall: 'صفحة التداول',
    OrderClosed: 'تم إغلاق الطلب',
    OrdersAppeal: 'الشكوى قيد التقدم',
    CancellationComplaint: 'إلغاء الشكوى',
    OrderException: 'خطاء في الطلب',
    ConfirmPayment: 'تأكيد الدفع',
    MarkedAsPaid: 'تم الدفع',
    NotYetPaid: 'إلغاء',
    payWarning: 'لا يوجد خصم تلقائي، قم بالتحويل يدويًا',
    PaymentAmount: 'المبلغ',
    PaymentReference: 'رقم المرجع',
    Otherparty: 'المشتري / البائع',
    ConfirmReleaseMoneyTitle: 'إلغاء الطلب',
    ConfirmReleaseMoneyWarning: 'تسجيل الدخول لتأكيد الاستلام',
    pass: 'كلمة مرور الاصول',
    passError: 'أدخل من 8-20 حرفًا، بشمل الأرقام والحروف',
    ConfirmReleaseMoneyConfrim: 'أنا أؤكد الاستلام',
    CancellationOrderTitle: 'إلغاء الطلب',
    CancellationOrderWarning1: 'لا يمكن استرجاع اصولك بعد إلغاء الطلب، إذا قمت بالدفع، الرجاء عدم إلغاء الطلب',
    CancellationOrderWarning2: 'قواعد إلغاء الطلب : إذا قمت بإلغاء 3 طلبات خلال 24 ساعة، سيتم تقييد وظيفة الشراء لمدة 24 ساعة',
    CancellationOrderConfrim: 'لم أدفع بعد',
    AppealTitle: 'الشكوى',
    AppealWarning: 'يمكن حل النزاعات من خلال الشكاوى',
    ReasonsAppeal: 'سبب الشكوى',
    CancellationComplaintTitle: 'إلغاء الشكوى',
    CancellationComplaintConfrim: 'إلغاء الشكوى يعني أنك ليس لديك نزاع على هذا الطلب، هل أنت متأكد من أنك تريد إلغاء الشكوى؟',
    AppealTitleFive: 'يمكن تقديم الشكوى بعد 5 دقائق من الدفع',
    PendingPayment: 'في انتظار الدفع',
    CountdownPayments: 'الوقت المتبقي للدفع',
    WaitingCountdownPayment: 'في انتظار عد تنازلي للدفع من المشتري',
    MoneyCollected: 'في انتظار البائع لإطلاق العملة',
    MoneyCollectedWarning: 'سوف تتلقى الاصول بعد تأكيد البائع',
    otherPartyPaid1: 'المشتري دفع',
    otherPartyPaid2: 'معلم ك',
    otherPartyPaid3: 'تم الدفع بنجاح',
    Completedbuy1: 'تم اكتمال الطلب',
    Completedbuy2: 'يمكنك التحقق من أصولك من خلال',
    Completedbuy3: 'عرض الأصول',
    Completedbuy4: 'النقل إلى حساب النقدي للتداول',
    CoCompletedbuy4: 'النقل إلى الحساب الرئيسي للتداول',
    Completedsell: 'تم اكتمال الطلب',
    TitleOrderClose: 'تم إغلاق الطلب',
    TitleOrderClose_buyer: 'ألغى المشتري الطلب، تم إغلاق الطلب',
    TitleOrderClose_timeout: 'انتهاء الوقت، تم إغلاق الطلب',
    TitleComplaint: 'الشكوى قيد التقديم',
    TitleComplaintText: 'خدمة العملاء لدينا تعمل من اجل حل المشكلة من أجلك، الرجاء الانتظار',
    TitleOrderException: 'خطاء في الطلب',
    AfterAppealbuy1: 'تم اكتمال الطلب',
    AfterAppealbuy2: 'يمكنك التحقق من أصولك من خلال',
    AfterAppealbuy3: 'عرض الأصول',
    AfterAppealbuy4: 'النقل إلى حساب النقدي للتداول',
    CoAfterAppealbuy4: 'النقل إلى الحساب الرئيسي للتداول',
    AfterAppealsell: 'تم اكتمال الطلب',
    barText: 'فتح الطلب',
    bar1Buy1: 'في انتظار الدفع',
    bar1Buy2: 'في انتظار البائع لإطلاق العملة',
    bar1Sell1: 'في انتظار الدفع',
    bar1Sell2: 'في انتظار البائع لإطلاق العملة',
    bar2Buy1: 'المشتري دفع',
    bar2Buy2: 'في انتظار البائع لإطلاق العملة',
    bar2Sell1: 'المشتري دفع',
    bar2Sell2: 'في انتظار البائع لإطلاق العملة',
    bar3Buy1: 'المشتري دفع',
    bar3Buy2: 'البائع أطلق العملة',
    bar3Sell1: 'المشتري دفع',
    bar3Sell2: 'البائع أطلق العملة',
    bar4Sell: 'تم إغلاق الطلب',
    bar5Sell: 'الشكوى قيد التقدم',
    bar7Sell: 'خطاء في الطلب',
    bar8Buy1: 'المشتري دفع',
    bar8Buy2: 'البائع أطلق العملة',
    bar8Sell1: 'المشتري دفع',
    bar8Sell2: 'البائع أطلق العملة',
    day: 'يوم',
    hour: 'ساعة',
    min: 'دقيقة',
    sec: 'ثانية',
    SellersPaymentMethod: 'معلومات الدفع - للبائع',
    paysBuy2: 'لقد قمت بالدفع، لايمكن عرض معلومات الدفع',
    paysBuy3: 'لقد قمت بالدفع، لايمكن عرض معلومات الدفع',
    paysSell3: 'تم اكتمال الطلب، لايمكن عرض معلومات الدفع',
    pays4: '  تم إغلاق الطلب، لايمكن عرض معلومات الدفع',
    pays5: 'الطلب قيد الشكوى، لايمكن عرض معلومات الدفع',
    pays7: 'خطاء في الطلب، لايمكن عرض معلومات الدفع',
    paysBuy8: 'لقد قمت بالدفع، لايمكن عرض معلومات الدفع',
    paysSell8: 'تم اكتمال الطلب، لايمكن عرض معلومات الدفع',
    MessPaymentReference: 'رقم مرجع الدفع',
    MessPrice: 'السعر',
    MessVolume: 'الحجم',
    MessTotol: 'المبلغ الإجمالي',
    MessMerchantRemarks: 'ملاحظات التاجر',
    none: 'لا يوجد',
    chatServer: 'خدمة العملاء',
    chatUser: 'التاجر',
    chatServerMessage: 'رسالة النظام: تم تقديم شكواك بنجاح، الرجاء الانتظار',
    chatServerInp: 'ارسل رسالتك',
    chatServerBut: 'إرسال',
    inline: 'متصل',
    outline: 'غير متصل',
    chatVolume: 'حجم المعاملة',
    chatUserInp: 'ارسل رسالتك',
    chatUserBut: 'إرسال',
    identification: 'التحقق من الهوية',
    connection: 'معلومات الاتصال',
    phone: 'رقم الهاتف',
    twoMin: 'يمكنك مشاهدته بعد دقيقتين من الدفع',
  },
  components: {
    alert: {
      buttonText: 'أنا أعرف',
    },
    dialog: {
      confirmText: 'تأكيد',
      closeText: 'إلغاء',
    },
    getCode: {
      button: 'إرسال رمز التحقق',
      after: 'إرسال مرة أخرى',
    },
    select: {
      noData: 'لا توجد بيانات',
    },
    otcReminder: {
      title: 'نصائح',
      text1: '1. تجنب ذكر بيتكوين أو اسم اي عملة رقمية أثناء التحويل لتجنب المشاكل. قد يتم رفض التحويل بين البائع والمشتري',
      text2: '2. استخدم فقط طرق الدفع المسجلة باسمك على المنصة، أو قد تواجة المخاطرة بالرفض من قبل البائع',
      text3: '3. بالنسبة للمعاملات الكبيرة، تجنب الدفع في اوقات متأخر. استخدم الدفعات المقسمة للتداول بشكل أفضل',
      text4: '4. بعد الدفع، انقر على \'لقد دفعت\'. يتم إطلاق الأصول الرقمية عند التأكد من قبل البائع',
    },
  },
  manageFinances: {
    manage_finances: 'إدارة المالية',
    subTitle: 'أداة استثمار موزعة تلقائيًا، توفر الوقت والجهد والقلق',
    record: 'سجل الاستثمار',
    day: 'يوم',
    recommend: 'التوصيات المختارة',
    safe: 'الحماية الأمنية',
    expected: 'المتوقع',
    rate: 'معدل العائد',
    timeLimit: 'المدة',
    people: 'مرات',
    join: 'الانضمام التراكمي',
    now: 'كسب المال الآن',
    yearRate: 'سنوي',
    dayRate: 'يومي',
    moreProducts: 'عرض المزيد من المنتجات',
    Repayment: 'طريقة السداد',
    ReleaseCycle: 'دورة الإطلاق',
    deadline: 'وقت انتهاء المشروع',
    startTime: 'وقت بدء الفائدة',
    exitTime: 'وقت الخروج عند الاستحقاق',
    times: 'مرات',
    availableBalance: 'الرصيد المتاح',
    goRecharge: 'شحن',
    buyNumber: 'عدد الشراء',
    feature: 'عائدك المتوقع',
    commonProblem: 'الأسئلة الشائعة',
    buyNow: 'شراء الآن',
    what: 'ما هو إدارة المالية؟',
    what_1: 'ما هو العملة متعددة؟',
    how: 'كيفية المشاركة؟',
    rule: 'قواعد استرداد منتجات الاستثمار؟',
    rule_1: 'قواعد استرداد العملة متعددة؟',
    forSafe: 'من أجل أمان حسابك، يرجى البدء أولاً بتفعيل التحقق من الهوية الشخصية',
    goAuth: 'تحقق',
    note1: 'إدارة المالية هي منتج استثماري عملة رقمية ذو دورات ثابتة يطلقه منصة التداول الرقمية BIKI، لكل خطة فترة تثبيت ومعدل عائد سنوي متوقع محدد، يمكنك اختيار الاكتتاب بحرية، بعد الشراء يتم تثبيت رأس المال، ويبدأ احتساب العائد حسب الوقت المتفق عليه، عند انتهاء الخطة يتم إلغاء تجميد رأس المال والعائد وتحويلهما إلى الحساب، وتحصل على العائد المتفق عليه.',
    note1_1: 'العملة متعددة هي منتج استثماري عملة رقمية ذو دورات ثابتة يطلقه منصة التداول الرقمية WBFex، لكل خطة فترة تثبيت ومعدل عائد سنوي متوقع محدد، يمكنك اختيار الاكتتاب بحرية، بعد الشراء يتم تثبيت رأس المال، ويبدأ احتساب العائد حسب الوقت المتفق عليه، عند انتهاء الخطة يتم إلغاء تجميد رأس المال والعائد وتحويلهما إلى الحساب، وتحصل على العائد المتفق عليه.',
    note2: 'قم بتسجيل الدخول إلى موقع التداول الرقمي الرسمي Biki www.biki.com، انقر على زر "الانتقال إلى الاستثمار" في إدارة الأصول، ثم اختر المنتج المناسب لك، أدخل كمية العملة، وانقر على "الانضمام الآن" للمشاركة في إدارة المالية.',
    note2_1: 'قم بتسجيل الدخول إلى موقع التداول الرقمي الرسمي لـ WBFex new.WBFex.com، انقر على زر "الانتقال إلى الاستثمار" في إدارة الأصول، ثم اختر المنتج المناسب لك، أدخل كمية العملة، وانقر على "الانضمام الآن" للمشاركة في العملة متعددة.',
    note3: 'وفقًا لقاعدة العائد أولاً ثم رأس المال، خلال فترة تثبيت المنتج، تكون أول دورة عائد هي 3 أسابيع، بعد 3 أسابيع يتم إعادة 3 أضعاف الفائدة، ثم إعادة الفائدة بانتظام أسبوعيًا بعد ذلك، وفي نهاية المدة يتم إعادة رأس المال.',
    inputNumber: 'يرجى إدخال عدد الشراء',
    buyNumMax: 'لا يجب أن يتجاوز عدد الشراء الرصيد المتاح',
    first: 'الفائدة أولاً ثم رأس المال',
    together: 'رأس المال والفائدة معًا',
    buyTime: 'وقت الشراء',
    name: 'اسم المشروع',
    orderNumber: 'رقم الطلب',
    coin: 'العملة',
    number: 'الكمية',
    tablerate: 'الفائدة (%)',
    status: 'الحالة',
    operating: 'العمليات',
    transferTime: 'وقت إعادة التحويل',
    returnCoin: 'إعادة عملة',
    returnNumber: 'إعادة الكمية',
    type: 'النوع',
    allType: 'جميع الأنواع',
    subscribed: 'مكتتب',
    interested: 'جارٍ حساب الفائدة',
    completed: 'مكتمل',
    interest: 'فائدة',
    principal: 'رأس المال',
  },
  footer: {
    terms: 'البنود',
    agreement: 'اتفاقية المستخدم',
    declaration: 'الإعلان القانوني',
    aboutChainup: 'حول',
    utils: 'أدوات',
    about: 'حول ChainUP',
    apply: 'طلب إضافة عملة',
    download: 'تنزيل التطبيق',
    api: 'وثائق API',
    media: 'وسائل التواصل الاجتماعي',
  },
  appDownLoad: {
    text1: 'تحميل أندرويد',
    text2: 'مسح للتحميل',
    text3: 'متجر Google Play',
    text4: 'تحميل الآن',
    text5: 'رابط التحميل',
    text6: 'تحميل آيفون',
    text7: 'Apple ID دولي',
    text8: 'TestFlight',
    text9: 'تعليمات التثبيت',
    title: 'تحميل تطبيق الهاتف',
    desc: 'تداول متعدد المنصات والأجهزة في أي وقت ومكان',
    platform: [
      'iOS',
      'اندرويد',
    ],
    twoDimension: 'مسح لتحميل التطبيق',
    headerCode: 'مسح لتحميل التطبيق',
    moreDown: 'المزيد من التحميلات',
    flag: [
      {
        title: 'أداء معاملات سريعة',
        desc: 'توفر أنواعًا متنوعة من التداول للاختيار من بينها، مطابقة أوامر فائقة السرعة، تحويل فوري، شراء وبيع أكثر سهولة',
      },
      {
        title: 'تحويل الأصول بسهولة',
        desc: 'تحويل سلس للأصول داخل الحساب، لمحة عامة في الوقت الفعلي عن الأصول الرقمية، إضافة مخطط كعكة لنسب العملات',
      },
      {
        title: 'تخصيص لوحة التداول',
        desc: 'تخصيص تخطيط التداول بحرية وفقًا لاختلاف عادات التداول، إضافة مداخل للرسم البياني وعمق السوق',
      },
      {
        title: 'إدارة الحسابات المتكاملة',
        desc: 'ضبط التحقق الأمني متعدد المستويات، إدارة حساب العملة القانونية وحساب التداول الفوري في حساب واحد',
      },
    ],
    setUp: {
      title: 'تعليمات التثبيت لمستخدمي iOS',
      step: [
        {
          step: 1,
          title: 'تحميل التطبيق',
          desc: 'افتح الإعدادات على الهاتف، ثم اختر "عام"؛',
        },
        {
          step: 2,
          title: 'إدارة الأجهزة',
          desc: 'من العام، اختر ميزة "الملفات وإدارة الأجهزة"؛',
        },
        {
          step: 3,
          title: 'اختيار التثبيت',
          desc: 'في ملفات وإدارة الأجهزة، ضمن التطبيقات المؤسسية، اختر اسم ملف التطبيق المؤسسي المراد تثبيته (يتطابق مع التلميح عند الفتح)، ثم انقر للدخول؛',
        },
        {
          step: 4,
          title: 'ضبط الثقة',
          desc: 'بعد الدخول إلى صفحة التوقيع المؤسسي، تأكد من اسم الشركة الموقعة واسم التطبيق، ثم انقر "ثقة" للشركة الموقعة؛',
        },
        {
          step: 5,
          title: 'تشغيل التطبيق',
          desc: 'ارجع إلى الشاشة الرئيسية، وأعد فتح التطبيق لاستخدامه.',
        },
      ],
    },
    setUpTestFlignt: {
      title: 'تعليمات التثبيت لمستخدمي iOS',
      step: [
        {
          step: 1,
          title: 'تحميل التطبيق',
          desc: 'انقر على "تثبيت TestFlight"، واتبع الإرشادات المعروضة، ثم افتح متجر APP Store وقم بتنزيل TestFlight؛',
        },
        {
          step: 2,
          title: 'تحميل TestFlight',
          desc: 'يمكنك أيضًا تنزيل TestFlight مباشرة من متجر APP Store إذا لم يكن منزلاً بالفعل، تجاهل هذه الخطوة إذا قمت بالتنزيل',
        },
        {
          step: 3,
          title: 'اختيار التثبيت',
          desc: 'افتح تطبيق TestFlight، واقبل إصدار Cobidex Beta، وافتحه للاستخدام؛ إذا قمت بالتنزيل بالفعل يمكنك القيام بـ "تحديث" للحصول على أحدث إصدار',
        },
      ],
    },
    download_text_1: 'توقيع مؤسسي IOS',
    download_text_2: 'APK أندرويد',
    download_text_3: 'TestFlight',
    download_text_4: 'متجر Google Play',
  },
  homeTemplate: {
    text_01: 'تداول متعدد المنصات والأجهزة في أي وقت ومكان',
    text_02: 'يغطي iOS وAndroid وWindows وMac على منصات متعددة، مع دعم جميع الميزات التجارية',
    text_03: 'تحميل التطبيق',
    text_04: 'المنتجات والخدمات',
    text_05: 'تقديم خدمات تداول وإدارة أصول رقمية آمنة وموثوقة لملايين المستخدمين حول العالم',
    text_06: 'نطاق عالمي',
    text_07: 'إنشاء مراكز خدمة تداول محلية في عدة بلدان لتكوين أشكال أعمال متعددة متكاملة',
    text_08: 'نظام أمان',
    text_09: 'فريق من الطراز الأول يقدم دفاعات أمنية متعددة المستويات مهنية لتبقى أصولك آمنة',
    text_10: 'نظام التداول',
    text_11: 'إنشاء مراكز خدمة تداول محلية في عدة بلدان لتكوين أعمال متعددة متكاملة',
    text_12: 'قابلية توسع عالية',
    text_13: 'تدفق سلس للأصول وتداول سلس بلا عوائق',
    text_14: 'ابدأ رحلة التداول الآن',
    text_15: 'تقديم أعمال تداول العملات الرقمية الكاملة مثل التداول بالعملات المشفرة والعملات القانونية والعقود',
    text_16: 'تسجيل فوري',
    text_17: 'تداول متعدد المنصات والأجهزة',
    text_18: 'مدير أصولك الشخصي',
    text_19: 'ابدأ الآن',
    text_20: 'تسجيل فوري',
    text_21: 'البريد الإلكتروني / رقم الهاتف',
    products: {
      text_1: 'المنتجات الأساسية',
      text_2: 'منصة متكاملة لتلبية جميع احتياجاتك',
      text_3: 'تداول العقود',
      text_4: 'دعم عقود USDT دائمة، شراء وبيع بلا حدود، ربح في أي وقت',
      text_5: 'تداول فوري',
      text_6: 'دعم تداول 100+ عملة مشفرة، بساطة وسهولة التشغيل',
      text_7: 'تداول بالعملات القانونية',
      text_8: 'إيداع عملات مشفرة وبدء التداول على الفور، مع دعم طرق دفع متعددة',
      text_9: 'بدء التداول الآن',
    },
    steps: {
      text_1: 'دقيقة واحدة، سهل الاستخدام',
      text_2: 'ابدأ رحلة التداول الآن',
      text_3: 'تسجيل حساب',
      text_4: 'تسجيل حساب في أي وقت ومكان',
      text_5: 'إيداع',
      text_6: 'إيداع عملات مشفرة في حسابك، مع دعم العديد من طرق الإيداع',
      text_7: 'تحقق من الهوية',
      text_8: 'أكمل التحقق من الهوية لحماية سلامة أصول حسابك',
      text_9: 'جاهز للاستمتاع برحلة التداول المشفرة!',
    },
    services: {
      text_1: 'المنتجات والخدمات',
      text_2: 'تقديم خدمات تداول وإدارة أصول رقمية آمنة وموثوقة لملايين المستخدمين حول العالم',
      text_3: 'نظام تداول رائد',
      text_4: 'فريق عالمي، تقنيات موازية موزعة، محرك مطابقة سريع، تجربة تداول سلسة',
      text_5: 'نظام إدارة مخاطر رائد يحميك',
      text_6: 'نظام مراقبة مخاطر رائد في السوق، يضمن أمان الأموال',
      text_7: 'وظائف منتجات متنوعة',
      text_8: 'منتجات عقود عالية الرافعة، تداول فوري متعدد العملات، إيداع وسحب سريع',
      text_9: 'خدمة عملاء رائدة',
      text_10: 'نظام خدمة متعدد اللغات والقنوات، مساعدتك في أي وقت',
    },
    text_22: 'تداول الان',
    text_23: 'اكمال التسجيل ، وتداول الان',
    footer: {
      title_1: 'من نحن',
      title_2: 'مساعدة',
      title_3: 'خدمات',
      title_4: 'منتجات',
      text_1_1: 'حول المنصة',
      text_1_2: 'مركز الإعلانات',
      text_1_3: 'اتفاقية المستخدم',
      text_1_4: 'بنود الخصوصية',
      text_1_5: 'تحذير المخاطر',
      text_1_6: 'إخلاء المسؤولية',
      text_2_1: 'مركز المساعدة',
      text_2_2: 'الرسوم القياسية',
      text_2_3: 'دليل العقود',
      text_3_1: 'الدعم عبر المحادثة',
      text_3_2: 'إرسال تذكرة',
      text_3_3: 'طلب إضافة عملة',
      text_3_4: 'تقديم طلب كتاجر',
      text_3_5: 'تنزيل التطبيق',
      text_4_1: 'تداول فوري',
      text_4_2: 'تداول العقود',
      text_4_3: 'تداول بالعملات القانونية',
    },
    text_24: 'يغطي iOS وAndroid عبر منصات متعددة، مع دعم جميع الميزات التجارية',
  },
  lever: {
    leverAccount: 'أصول الرافعة',
    leverKy: 'متاح',
    leverKj: 'قابل للاقتراض',
    leverYj: 'مقترض',
    leverjd: 'اقتراض',
    fxl: 'معدل المخاطر',
    leverText1: 'إجمالي الأصول/الأصول المقترضة * 100٪',
    leverText2: 'عندما يكون معدل المخاطر ≤110٪، سيتم تصفية الحساب قسريًا لسداد الأموال المقترضة',
    bcj: 'سعر التصفية',
    leverHz: 'تحويل',
    leverJd: 'اقتراض',
    leverZded: 'الحد الأقصى',
    leverLl: 'الفائدة',
    all: 'الكل',
    leverJdcc: 'نجح الاقتراض',
    leverJdNumber: 'كمية الاقتراض',
    buy: 'شراء/عمل شراء',
    sell: 'بيع/عمل بيع',
    alertTitle: 'تنبيه',
    your: 'رصيدك في',
    alertTet: 'غير كافٍ للتداول بالرافعة، يجب تحويل الأصول أولاً.',
    hzBtntext: 'تحويل الآن',
  },
  contract: {
    co: 'عقد',
    co2: 'العقد',
    contractType1: 'دائم',
    contractType2: 'أسبوعي',
    contractType3: 'أسبوع التالي',
    contractType4: 'شهري',
    contractType5: 'ربع سنوي',
    applies: 'التغير النسبي',
    height: 'السعر الأعلى',
    low: 'السعر الأدنى',
    H_volume: 'الحجم خلال 24 ساعة',
    handicap: 'السوق',
    latestDeal: 'آخر صفقة',
    number: 'عدد المراكز الحالية',
    price: 'السعر',
    total: 'الإجمالي',
    time: 'الوقت',
    volume: 'حجم التداول',
    addEnsure: 'زيادة الهامش',
    minusEnsure: 'تخفيض الهامش',
    fqEnsure: 'هامش مخصص',
    kyEnsure: 'هامش متاح',
    addMinusEnsure: 'زيادة وتخفيض الهامش',
    addEnsureNumbere: 'زيادة كمية الهامش',
    minusEnsureNumbere: 'تخفيض كمية الهامش',
    infoOrder: 'أمر محدد السعر',
    marketOrder: 'أمر بالسعر السوقي',
    cancel: 'إلغاء',
    closePrice: 'إغلاق بالسعر السوقي',
    limitPrice: 'إغلاق بسعر محدد',
    contractId: 'معرف العقد',
    accountId: 'معرف المركز',
    coNumber: 'عدد المراكز',
    piece: 'عقد',
    holding: 'المراكز المفتوحة',
    currentEntrust: 'الأوامر الحالية',
    dayTrading: 'تداولات اليوم',
    historyEntru: 'الأوامر السابقة',
    nowList1: 'الوقت',
    nowList2: 'العقد',
    nowList3: 'عدد المراكز (عقد)',
    nowList4: 'سعر الأمر',
    nowList5: 'تم التنفيذ',
    nowList6: 'المتبقي',
    nowList7: 'القيمة',
    nowList8: 'متوسط السعر',
    nowList9: 'النوع',
    nowList10: 'الحالة',
    nowList11: 'العمليات',
    nowList12: 'سعر التنفيذ',
    nowList13: 'سعر الافتتاح',
    nowList14: 'سعر العلامة',
    nowList15: 'سعر التصفية القسرية',
    nowList16: 'الربح/الخسارة غير المحققة',
    nowList17: 'الربح/الخسارة المحققة',
    nowList18: 'معدل العائد',
    nowList19: 'الهامش',
    nowList20: 'معرف الأمر',
    status1: 'أمر جديد',
    status2: 'تم التنفيذ بالكامل',
    status3: 'تم التنفيذ جزئيًا',
    status4: 'تم الإلغاء',
    status5: 'بانتظار الإلغاء',
    status6: 'ملغى',
    status7: 'تم الإلغاء جزئيًا بعد تنفيذ جزئي',
    c_success: 'نجح الأمر',
    cancel_success: 'نجح الإلغاء',
    c_error: 'فشلت العملية',
    cost: 'التكلفة',
    orders: 'قيمة الأمر',
    balance: 'الرصيد المتاح',
    entryPrice: 'سعر الدخول',
    liquidationPrice: 'سعر التصفية القسرية',
    bjPrice: 'سعر العلامة',
    liquidationPriceTwo: 'توقع سعر التصفية القسرية',
    value: 'القيمة',
    chiccw: 'المراكز المفتوحة',
    multipleb: 'مضاعف الرافعة',
    marketPrice: 'السعر السوقي',
    cw: 'المركز',
    rate: 'معدل العائد',
    buyButton: 'شراء/عمل شراء',
    sellButton: 'بيع/عمل بيع',
    loginReg: 'تسجيل الدخول / التسجيل',
    buy: 'شراء',
    sell: 'بيع',
    errorText_01: 'الحد الأقصى لعدد المراكز القابلة للإدخال',
    errorText_02: 'الحد الأدنى لعدد المراكز القابلة للإدخال',
    limitPriceTrade: 'تداول محدد السعر',
    marketPriceTrade: 'تداول بالسعر السوقي',
    deliveryTime: 'المتبقي حتى التسليم',
    day: 'يوم',
    success: 'نجاح',
    pleprice: 'الرجاء إدخال سعر الإغلاق',
    Value: 'القيمة',
    Chiccw: 'مركزك',
    Multipleb: 'الرافعة',
    Piece: 'عقد',
    closeToMark: 'سعر التفعيل قريب جدًا من سعر العلامة، فشل الأمر.',
  },
  tradeLimt: {
    tradeLimit_text_everyDayCount: 'يوجد حد لعدد التداولات اليومية لهذا الزوج',
    tradeLimit_text_everyDayBuy: 'الحد الأقصى للشراء في اليوم هو:',
    tradeLimit_text_everyDaySell: 'الحد الأقصى للبيع في اليوم هو:',
    tradeLimit_text_noLimitBuy: 'لا يوجد حد لعمليات الشراء',
    tradeLimit_text_noLimitSell: 'لا يوجد حد لعمليات البيع.',
    tradeLimit_text_instructions: 'تعليمات التداول',
    tradeLimit_text_everyDayBuy_end: ' ',
    tradeLimit_text_everyDaySell_end: ' ',
  },
  market: {
    allMarket: 'كل الأسواق',
    text1: 'نظرة عامة',
    text2: 'التداول',
    text3: 'معلومات أساسية',
    vol: 'الكمية',
    noDataDesc: 'لا توجد مفضلات حاليًا، اذهب إلى السوق لإضافة',
    noData: 'لا توجد بيانات حاليًا',
    addFavorites: 'إضافة مفضلة',
    exchange: 'التداول الفوري',
    futures: 'العقود الدائمة',
  },
  kyc: {
    success: 'تم الإرسال بنجاح',
    error: 'فشل التحقق',
    text1: 'تعذر الوفاء بمتطلبات التحقق، يرجى العودة إلى المركز الشخصي وإعادة تقديم طلب التحقق من الهوية',
    text2: 'يحتوي الحساب على معلومات تحقق من الهوية بالفعل، لا يمكن تقديم طلب تحقق من الهوية مرة أخرى.',
    text3: 'لا يمكن التحقق مرة أخرى من معلومات التحقق من الهوية المحققة بالفعل',
    text4: 'تم تقديم معلوماتك، مدة المراجعة دقيقة واحدة، يمكنك مراجعة النتيجة في صفحة "المركز الشخصي".',
  },
  weeks: {
    0: 'الأحد',
    1: 'الاثنين',
    2: 'الثلاثاء',
    3: 'الأربعاء',
    4: 'الخميس',
    5: 'الجمعة',
    6: 'السبت',
  },
  months: {
    0: 'يناير',
    1: 'فبراير',
    2: 'مارس',
    3: 'أبريل',
    4: 'مايو',
    5: 'يونيو',
    6: 'يوليو',
    7: 'أغسطس',
    8: 'سبتمبر',
    9: 'أكتوبر',
    10: 'نوفمبر',
    11: 'ديسمبر',
  },
  mobilityTrade: {
    addPrice: 'أدخل السعر',
    addVolume: 'أدخل الحجم',
    priceSell: 'البيع حسب السعر',
    smallAmount: 'صفقات سريعة صغيرة، 0 رسوم',
    tradeType: 'نوع',
    immediately: 'تداول فوري',
    immediatelyBuy: 'شراء فوري',
    immediatelySell: 'بيع فوري',
    priceBuy: 'الشراء حسب السعر',
    volumeBuy: 'الشراء حسب الحجم',
    volumeSell: 'البيع حسب الحجم',
    referencePrice: 'السعر المرجعي',
    referenceWarn: 'يتم حساب السعر المرجعي من السوق الرئيسية وليس السعر النهائي. كمرجع فقط',
    coin: 'عملة',
    legal: 'عملة نقدية',
    all: 'الكل',
    buyPayments: 'حدد طريقة الدفع',
    sellPayments: 'حدد طريقة الاستلام',
    addPayments: 'أضف طريقة استلام',
    noPayments: 'لا توجد طريقة استلام، قم بأعدادها من خلال مركز المستخدم',
    tradePrice: 'سعر المعاملة',
    tradeVolume: 'عدد المعاملة',
    tradeSum: 'المبلغ المدفوع',
    warn: 'بسبب تقلبات اسعار السوق، قد يتغير السعر المتطابق قليلا. احجز طلبك في أقرب وقت ممكن!',
    btnHis: 'انتهت صلاحية السعر، انقر للتحديث',
    warn1: 'الحصول عليه بعد إدخال مبلغ الشراء',
    warn2: 'الحصول عليه بعد إدخال حجم الشراء',
    warn3: 'الحصول عليه بعد إدخال مبلغ البيع',
    warn4: 'الحصول عليه بعد إدخال حجم البيع',
    error1: 'الحد الأقصى لمبلغ الطلب هو',
    error2: 'نطاق مبلغ الطلب هو',
    error3: 'الحد الأقصى لحجم الطلب هو',
    error4: 'نطاق حجم الطلب هو',
    error5: 'لا توجد عروض مناسبة، يرجى تعديل شروط الطلب',
    error6: 'أضف طريقة استلام أولا',
  },
  freeStaking: {
    incomeFilter: [
      'وصول عائدات الاستثمار',
      'تثبيت رأس المال الاستثماري',
      'إطلاق رأس المال الاستثماري',
    ],
    home: {
      status: [
        'بانتظار البدء',
        'جاري الاكتتاب',
        'بانتظار حساب الفائدة',
        'جاري حساب الفائدة',
        'انتهى حساب الفائدة',
        'إطلاق رأس المال',
        'تم الوفاء بالحد الأقصى',
        'انتهى',
      ],
      notice: 'عرض الإعلانات',
      title: 'أنواع العوائد على العملات المملوكة',
      gainRate: 'معدل العائد السنوي المتوقع',
      lockDay: 'أيام التثبيت',
      lockProgress: 'تقدم التثبيت',
      takeActivity: 'عرض النشاط',
      contactUS: 'اتصل بنا',
      FQA: 'الأسئلة الشائعة',
      income: 'العائدات',
    },
    detail: {
      activityProgress: 'تقدم النشاط',
      lockAllNum: 'إجمالي التثبيت',
      lockNum: 'كمية التثبيت',
      lockMinNum: 'الحد الأدنى للتثبيت في كل مرة:',
      lockMaxNum: 'الحد الأقصى التراكمي للتثبيت:',
      userLocked: 'لقد قمت بالتثبيت',
      twoDayIncome: [
        'يوم',
        'العائد المتوقع:',
      ],
      totalGainAmount: 'المنصة الموزعة التراكمية',
      totalUserGainAmount: 'ما حصلت عليه حتى الآن',
      rulesDangers: 'أقر بأنني على دراية تامة بمخاطر المشروع',
      agreePOS: 'موافق على PoS',
      activityStatus: [
        'بدء الاكتتاب',
        'انتهاء الاكتتاب',
        'بدء الفائدة',
        'إيقاف الفائدة',
        'إطلاق المبلغ الأصلي',
      ],
      incomeTime: 'وقت العائد',
      incomeNum: 'كمية العائد',
      incomeDetail: 'تفاصيل العائد',
      balanceError: [
        'لا يمكن أن تتجاوز كمية التثبيت',
        'من رصيدك',
      ],
      buyAmountMinError: [
        'لا يقل عن الحد الأدنى للكمية في كل مرة',
      ],
      buyAmountMaxError: [
        'لا يتجاوز الحد الأقصى التراكمي للتثبيت',
      ],
      buySuccess: 'تم الشراء بنجاح',
    },
    myPos: {
      lockPosTable: [
        'العملة',
        'وقت بدء التثبيت',
        'كمية التثبيت',
        'معدل العائد السنوي المتوقع',
        'العائد الحالي من التثبيت',
        'حالة PoS',
      ],
      unLockPosTable: [
        'العملة',
        'تاريخ العائد',
        'المبلغ الأصلي',
        'معدل العائد السنوي',
        'كمية العائد',
      ],
      lockPOS: 'PoS بروتوكول',
      havePOS: 'PoS مملوك',
      endTime: 'وقت الانتهاء',
    },
  },
  singPassLogin: {
    mainText1: 'طرق تسجيل الدخول الأخرى',
    mainText2: 'تسجيل الدخول عبر SingPass',
    mainText3: 'انتهت صلاحية رمز الاستجابة السريعة',
    mainText4: 'انقر للتحديث',
    mainText5: 'افتح',
    mainText6: 'SingPass للهاتف',
    mainText7: 'مسح لتسجيل الدخول',
    mainText8: 'ليس لديك تطبيق SingPass بعد؟',
    mainText9: 'قم بالتنزيل',
    mainText10: 'لم ترتبط حساباتك بعد، يرجى اختيار طريقة الارتباط',
    mainText11: 'ارتباط بحساب جديد',
    mainText12: 'ارتباط بحساب حالي',
    mainText13: 'تسجيل الدخول وارتباط حساب SingPass',
    mainText14: 'التسجيل وارتباط حساب SingPass',
    mainText15: 'التسجيل عبر SingPass',
  },
  registerOptions: {
    title: 'تنبيه أمني',
    text: 'بسبب عدم استقرار شبكات مشغلي الهاتف المحمول، قد يكون هناك تأخير في استلام الرسائل القصيرة في منطقتك الحالية، ننصح باستخدام المصادقة عبر Google',
    conf: 'ربط Google',
    close: 'متابعة ربط رقم الهاتف',
  },
  futures: {
    currentSymbol: {
      title1: 'سعر العلامة',
      title2: 'سعر المؤشر',
      title3: 'معدل التمويل الحالي',
      title4: 'التوقعات لمعدل التمويل القادم',
      title5: 'حجم التداول خلال 24 ساعة',
      explain1: 'يُستخدم سعر العلامة لتسوية الأرباح والخسائر وتفعيل التصفية القسرية. قد يختلف عن آخر سعر سوقي لمنع الخسائر الناجمة عن التلاعب في السوق.',
      explain2: 'سعر السوق العادل للعملة الأساسية.',
      explain3: 'سيتم التسوية بهذه القيمة عند انتهاء معدل التمويل الحالي.',
      explain4: 'يتم تسوية رسوم التمويل كل 8 ساعات (لحاملي المراكز فقط)، في الساعة 00:00 و08:00 و16:00 بتوقيت UTC.<br />رسوم التمويل = معدل التمويل الفوري عند التسوية * قيمة المركز <br />قيمة المركز = عدد العقود * القيمة الاسمية * سعر العلامة',
      explain5: 'من المتوقع التسوية بهذه القيمة عند انتهاء معدل التمويل القادم.',
      explain6: 'يدفع أصحاب المراكز الطويلة رسوم تمويل لأصحاب المراكز القصيرة، والعكس إذا كان معدل التمويل سالبًا.',
      marginModel1: 'مراكز مشتركة',
      marginModel2: 'مراكز منفصلة',
    },
    depth: {
      text1: 'قائمة الوكالات',
      text2: 'الصفقات الفورية',
      text3: 'المؤشرات',
      text4: 'العمق',
      text5: 'وسم',
      theadList1: 'السعر',
      theadList2: 'الكمية',
      theadList3: 'المجموع',
    },
    market: {
      text1: 'عقد',
      text2: 'آخر سعر',
      text3: 'نسبة الارتفاع والانخفاض',
      text4: 'عقود USDT',
      text5: 'عقود عملة أساسية',
      text6: 'عقود مختلطة',
      text7: 'عقود تجريبية',
      text8: 'البحث عن العملات',
    },
    newTrade: {
      text1: 'صفقات فورية',
      text2: 'السعر',
      text3: 'الكمية',
      text4: 'الوقت',
    },
    orderList: {
      tabType1: 'مراكز',
      tabType2: 'أوامر عادية',
      tabType3: 'أوامر شرطية',
      tabType4: 'أوامر تاريخية',
      tabType5: 'تدفقات رأس المال',
      subTabType1: 'الكل',
      subTabType2: 'أوامر توقف الخسارة',
      subTabType3: 'أوامر الربح',
      a_columns_1: 'العقد',
      a_columns_2: 'الاتجاه',
      a_columns_3: 'الكمية',
      a_columns_4: 'الإكمال',
      a_columns_5: 'سعر الأمر',
      a_columns_6: 'متوسط السعر',
      a_columns_7: 'النوع',
      a_columns_8: 'تقليل المركز فقط',
      a_columns_9: 'الوقت',
      a_columns_10: 'العمليات',
      b_columns_1: 'العقد',
      b_columns_2: 'الاتجاه',
      b_columns_3: 'سعر التفعيل',
      b_columns_4: 'سعر الأمر',
      b_columns_5: 'كمية/قيمة الأمر',
      b_columns_6: 'النوع',
      b_columns_7: 'تقليل المركز فقط',
      b_columns_8: 'وقت الإرسال',
      b_columns_9: 'وقت الانتهاء',
      c_columns_1: 'العقد',
      c_columns_2: 'النوع',
      c_columns_3: 'الاتجاه',
      c_columns_4: 'سعر الأمر',
      c_columns_5: 'كمية/قيمة الأمر',
      c_columns_6: 'الكمية المنفذة',
      c_columns_7: 'متوسط السعر',
      c_columns_8: 'الربح والخسارة',
      c_columns_9: 'الحالة',
      c_columns_10: 'الوقت',
      c_columns_11: 'الرسوم',
      d_columns_1: 'الوقت',
      d_columns_2: 'النوع',
      d_columns_3: 'المبلغ',
      d_columns_4: 'العملة',
      typeStatus1: 'أمر محدد السعر',
      typeStatus2: 'أمر بالسعر السوقي',
      typeStatus3: 'صانع السوق فقط',
      typeStatus4: 'إغلاق قسري للمركز',
      typeStatus5: 'دمج المراكز',
      getStatus1: 'أمر جديد',
      getStatus2: 'منفذ بالكامل',
      getStatus3: 'منفذ جزئيا',
      getStatus4: 'ملغي',
      getStatus5: 'بانتظار الإلغاء',
      getStatus6: 'أمر غير طبيعي',
      getStatus7: 'ملغى جزئيا بعد تنفيذ جزئي',
      sideT1: 'فتح',
      sideT2: 'إغلاق',
      sideT3: 'بيع',
      sideT4: 'شراء',
      mPrice: 'السعر السوقي',
      isclose1: 'نعم',
      isclose2: 'لا',
      cancel: 'إلغاء',
      allCancel: 'إلغاء الكل',
      close_all_position: 'إغلاق كل المراكز',
      close_all_tip: 'سيؤدي إغلاق كل المراكز إلى إلغاء جميع الأوامر المعلقة في عقود العملة الأساسية، وإرسال أوامر بالسعر السوقي لإغلاق جميع مراكز عقود العملة الأساسية. هل تريد بالتأكيد إغلاق كل المراكز؟',
      tstext1: 'يرجى',
      tstext2: 'تسجيل الدخول / الاشتراك',
      tstext3: 'قبل إجراء العملية',
      memoText1: 'إلغاء المستخدم',
      memoText2: 'أمر غير طبيعي، تم إلغاؤه من قبل النظام',
      memoText3: 'حدث إغلاق قسري للمركز، تم إلغاء الأوامر غير المنفذة من قبل النظام',
      memoText4: 'عدم كفاية سيولة الطرف المقابل، تم إلغاء الأمر من قبل النظام',
      memoText5: 'أمر FOK، تم إلغاؤه من قبل النظام لعدم التنفيذ الكامل',
      memoText6: 'أمر IOC، تم إلغاء جزء منه من قبل النظام لعدم التنفيذ الفوري',
      memoText7: 'أمر سلبي، تم إلغاء جزء منه عند المطابقة كتاكر',
      memoText8: 'لا يوجد مركز، تم إلغاء أمر الإغلاق من قبل النظام',
      newText1: 'سجل الربح والخسارة',
      newText2: 'سجل التداول',
      newText3: 'متوسط سعر الفتح',
      newText4: 'متوسط سعر الإغلاق',
      newText5: 'كمية المركز',
      newText6: 'الربح والخسارة المحققة',
      newText7: 'إجمالي الربح والخسارة هو إجمالي الربح والخسارة المتراكمة خلال فترة احتفاظ هذا المركز. إجمالي الربح والخسارة = الرسوم + تكاليف التمويل + ربح وخسارة المركز + التوزيع',
      newText8: 'مجموع رسوم الفتح والإغلاق',
      newText9: 'تكاليف التمويل',
      newText10: 'إجمالي تكاليف التمويل خلال فترة احتفاظ المركز',
      newText11: 'ربح وخسارة المركز هو مجموع أرباح وخسائر كل عملية إغلاق للمركز. يتم احتساب ربح وخسارة الإغلاق بناءً على متوسط سعر الاحتفاظ قبل الإغلاق ومتوسط سعر الإغلاق',
      newText12: 'التوزيع',
      newText13: 'وقت الإغلاق',
      newText14: 'الدور',
      newText15: 'ربح/خسارة المركز',
      newText16: 'لهذا العقد فقط',
    }, // 2810
    tradeForm: {
      mPrice: 'السعر السوقي',
      textjz: 'القيمة',
      text1: 'إرسال أمر',
      text2: 'متاح',
      text3: 'الرصيد المتاح هو الأموال التي يمكن للمستخدم التصرف بها بحرية. يتم استخدام الرصيد المتاح كأولوية كهامش للمراكز مطلقة المخاطر، وينخفض عندما تتكبد المراكز مطلقة المخاطر خسائر.',
      text4: 'فترة صلاحية',
      text5: 'تكلفة',
      text6: 'تقليل المركز فقط',
      text7: 'تقلل أوامر تقليل المركز من المركز فقط، ولا تزيده.',
      text8: 'السعر',
      text9: 'الكمية',
      text10: 'عقد',
      text11: 'سعر الأمر',
      text12: 'سعر التفعيل',
      text13: 'عندما يصل سعر العلامة لهذا العقد إلى هذا السعر، سيقوم النظام بإرسال أمر نيابة عنك بالسعر والكمية التي حددتها.',
      text14: 'قيمة الافتتاح',
      text15: 'القيمة المطلوبة للمركز الذي تريد فتحه، قيمة المركز = كمية المركز * سعر التنفيذ، تعتمد الكمية الفعلية المنفذة للمركز على سعر التنفيذ الفعلي.',
      text16: '24 ساعة',
      text17: '7 أيام',
      text18: '14 يوم',
      text19: '30 يوم',
      text20: 'افتتاح',
      text21: 'إغلاق',
      text22: 'أمر محدد السعر',
      text23: 'أمر بالسعر السوقي',
      text24: 'أمر شرطي',
      text25: 'يمكن إغلاق البيع',
      text26: 'يمكن إغلاق الشراء',
      text27: 'يمكن الشراء',
      text28: 'يمكن البيع',
      text29: 'صانع السوق فقط',
      text30: 'تضمن أوامر صانع السوق فقط (Post-Only) أن يكون المستخدم صانع سوق، لا يتم تنفيذ هذا الأمر فورًا في السوق، وإذا كان هذا الأمر سيتم تنفيذه فورًا مع أمر حالي، فسيتم إلغاؤه فورًا.',
      text31: 'تُلغى الأجزاء غير المنفذة فورًا من أمر IOC (Immediately or Cancel) إذا لم يتم تنفيذها فورًا.',
      text32: 'يتم إلغاء أمر FOK (Fill or Kill) بالكامل فورًا إذا لم يتم تنفيذه بالكامل.',
      text33: 'تفعيل التداول بالعقود',
      text34: 'قم بتسجيل الدخول للتداول',
      text35: 'شراء لإغلاق البيع',
      text36: 'بيع لإغلاق الشراء',
      text37: 'شراء لفتح شراء',
      text38: 'بيع لفتح بيع',
      text39: 'شراء لعمل شراء',
      text40: 'بيع لعمل بيع',
      text41: 'انحراف السعر كبير جدًا!',
      text42: 'تجاوز الحد الأقصى لمبلغ الأمر، يمكن إدخال',
      text43: 'أقل من الحد الأدنى لمبلغ الأمر، يتطلب إدخال',
      text44: 'تجاوز الحد الأقصى لكمية الأمر، يمكن إدخال',
      text45: 'أقل من الحد الأدنى لكمية الأمر، يتطلب إدخال',
      text46: 'تجاوز الكمية القابلة للإغلاق!',
      text47: 'يرجى إدخال السعر',
      text48: 'يرجى إدخال الكمية',
      text49: 'يرجى إدخال قيمة الافتتاح',
      text50: 'يرجى إدخال سعر التفعيل',
      text51: 'رصيد الهامش غير كاف!',
      text52: 'السعر السوقي آنذاك',
      text53: 'كمية الأمر',
      text54: 'يوجد أمر حالي لهذا العقد، لا يمكن تعديل الرافعة المالية',
      text55: 'يوجد أمر/مركز حالي لهذا العقد، لا يمكن تعديل نوع المركز',
      text56: 'تجاوز الحد الأقصى لكمية الأمر، يمكن إرسال ',
      text57: 'تجاوز الحد الأقصى لمبلغ الأمر',
      text58: 'السعر أقل من الحد الأدنى المسموح',
      text59: 'السعر أعلى من الحد الأقصى المسموح',
    },
    calculator: {
      text1: 'الحاسبة',
      text2: 'مضاعف الرافعة',
      text3: 'الحد الأقصى للمراكز بالرافعة الحالية',
      text4: 'احسب',
      text5: 'النتيجة',
      text6: 'هامش الافتتاح',
      text7: 'مبلغ العائد',
      text8: 'معدل العائد',
      text9: 'سعر الإغلاق',
      text10: 'لا يمكن بلوغ هذا معدل العائد',
      text11: 'سعر التصفية القسرية',
      text12: 'سعر الافتتاح',
      text13: 'سعر الإغلاق',
      text14: 'الكمية',
      text15: 'عقد',
      text16: 'الربح',
      text17: 'مركز شراء',
      text18: 'مركز بيع',
      text19: 'شراء لعمل شراء',
      text20: 'بيع لعمل بيع',
      text21: 'كمية المركز',
      text22: 'كمية الهامش',
      text23: 'الهامش غير كافٍ للافتتاح',
      text24: 'لن يتم التصفية القسرية',
      text25: 'نتائج الحساب للإرشاد فقط، قد تختلف في الواقع بسبب الرسوم ومعدلات التمويل.',
      text26: 'مراكز مشتركة',
      text27: 'مراكز منفصلة',
      text28: 'الرصيد المتاح غير كافٍ لاستيفاء الحد الأدنى من هامش افتتاح هذا المركز',
      text29: 'متاح',
      text30: 'زيادة الهامش',
    },
    depositMode: {
      text1: 'نمط الهامش المشترك: يتشارك جميع المراكز في الهامش المتوفر في حساب العقود لتجنب التصفية القسرية. قد يخسر المتداول جميع الهامش والمراكز في حالة التصفية القسرية.',
      text2: 'نمط الهامش المنفصل: يتم تخصيص كمية محددة من الهامش لكل مركز. إذا انخفض هامش المركز إلى ما دون مستوى الهامش المحافظ، يتم تصفية المركز قسريًا. في النمط المنفصل، يمكنك إضافة أو خفض الهامش لهذا المركز.',
      text3: 'تعيين كمشترك',
      text4: 'تعيين كمنفصل',
      text5: 'يرجى تسجيل الدخول أولاً',
      text6: 'مشترك بالفعل',
      text7: 'منفصل بالفعل',
      text8: 'لا يمكن تغيير نمط الهامش عند وجود مراكز/أوامر',
      text9: 'مشترك',
      text10: 'منفصل',
      text12: 'نمط الهامش',
      tradingMode: 'نمط التداول',
      merge: 'دمج',
      split: 'تقسيم',
      position_mode: 'نمط المركز',
      merge_mode: 'الدمج: تدمج الأوامر في نفس الاتجاه (شراء أو بيع) لنفس زوج التداول في مركز واحد. يمكن أن يكون هناك مركزان فقط لكل زوج تداول، واحد للشراء وآخر للبيع. يمكن ضبط رافعة جميع مراكز زوج التداول معًا في منطقة الأوامر. تظهر المراكز المفتوحة بالرافعة المحدثة بعد التعديل.',
      split_mode: 'التقسيم: يمكن فتح مراكز منفصلة لنفس الاتجاه (شراء أو بيع) في نفس زوج التداول. لا تدمج الأوامر الجديدة مع المراكز الموجودة، ويمكن أن يكون هناك مراكز شراء وبيع متعددة لكل زوج تداول. تتمتع كل مركز برافعة مستقلة، وتؤثر رافعة منطقة الأوامر فقط على المراكز المفتوحة الجديدة.',
    },
    reminder: {
      text1: 'سعر التفعيل',
      text2: 'السعر',
      text3: 'عدم التذكير مرة أخرى، يمكنك إعادة الضبط في تفضيلات التداول',
      text4: 'المبلغ',
      text5: 'الكمية',
      text6: 'الهامش المستخدم',
      text7: 'هامش الأمر',
      text8: 'أمر محدد السعر',
      text9: 'أمر بالسعر السوقي',
      text10: 'أمر شرطي',
    },
    lever: {
      text1: 'مضاعف الرافعة',
      text2: 'أقصى رافعة مدعومة للمراكز الحالية',
      text3: 'الحد الأقصى للمراكز بالرافعة الحالية تقريبًا',
      text4: 'تأكيد',
      text5: 'يرجى تسجيل الدخول أولاً',
      text6: 'لا يمكن تعديل الرافعة لوجود أوامر لهذا العقد',
      text7: 'رافعة العقد',
      text8: 'لا يمكن أن يقل مضاعف الرافعة عن',
    },
    openFutures: {
      titleText: 'تنبيه فتح العقود',
      openTips: 'عزيزي المستخدم، لم تقم بعد بتفعيل العقود الدائمة، يمكنك القيام بعمليات العقود الدائمة بعد التفعيل!',
      confirmText: 'تفعيل العقود',
      cancelText: 'لاحقًا',
      agreeText: 'لقد فهمت مخاطر العقود وأوافق',
      agreeLink: 'اتفاقية خدمات العقود الدائمة',
      question1: '1. ما هو الحد الأقصى لنسبة الربح والخسارة التي قد تواجهها في هذه المعاملات؟',
      answer1_1: 'لا حدود للربح والخسارة',
      answer1_2: 'أقل من 50٪',
      question2: '2. من سيتحمل المسؤولية إذا خسرت بعض أو كل أموالك في التداول؟',
      answer2_1: 'عليك تحمل هذا، لأنه اختيار عقلاني قمت به منفردًا',
      answer2_2: 'ستتحمل المنصة المسؤولية',
      protocolLink: 'https://exchange.zendesk.com/hc/ar/articles',
    },
    positionLis: {
      columns1: 'العقد',
      columns2: 'المركز/القابل للتصفية',
      columns3: 'سعر التكلفة',
      columns4: 'سعر العلامة',
      columns5: 'سعر التصفية المتوقع',
      columns6: 'الهامش',
      columns7: 'نسبة الهامش',
      columns8: 'الربح/نسبة العائد',
      columns9: 'العمليات',
      columns10: 'وقف الربح ووقف الخسارة',
      textQuickClosing: 'إغلاق سريع',
      text1: 'أدخل السعر',
      text2: 'إغلاق بسعر محدد',
      text3: 'إغلاق بسعر السوق',
      text4: 'الكمية',
      text5: 'عقد',
      text6: 'المركز: حجم المركز الذي تمتلكه حاليًا. القيم الإيجابية تشير إلى مراكز طويلة (شراء) والقيم السلبية تشير إلى مراكز قصيرة (بيع). <br /> القابل للتصفية: الكمية المتبقية للتصفية. تقليل الكمية المتاحة سيقلل من القابل للتصفية.',
      text7: 'سعر الشراء أو البيع الذي تم من خلاله فتح المركز.',
      text8: 'سعر العلامة يُستخدم لحساب الربح والخسارة وتفعيل إجراءات الإغلاق. يمكن أن يختلف سعر العلامة عن أحدث سعر في السوق لمنع الاحتيال.',
      text9: 'عندما يقترب سعر العلامة من هذا السعر، سيتم إغلاق المركز تلقائيًا.',
      text10: 'الأصول المستخدمة لتأمين هذا المركز. الهامش الثابت يعتبر الأصول الفعلية المستخدمة للتأمين. الهامش الكامل يعتبر الأصول المطلوبة للتأمين بالنسبة للرافعة الحالية.',
      text11: 'نسبة الهامش تُستخدم لتقدير مخاطر الإغلاق القسري. عندما تكون نسبة الهامش أقل من أو تساوي 100٪، سيتم إغلاق المركز المقابل تلقائيًا.',
      text12: 'الربح غير المحقق هو الربح أو الخسارة غير المتحققة في المراكز غير المغلقة منذ فتح المركز حتى الآن. الربح غير المحقق للمراكز الطويلة = (سعر العلامة - سعر الافتتاح) × الكمية، والربح غير المحقق للمراكز القصيرة = (سعر الافتتاح - سعر العلامة) × الكمية <br /> نسبة العائد تُعبر عن العائد المتوسط على الهامش المستخدم. نسبة العائد = الربح / الهامش المستخدم.',
      text13: 'أوامر وقف الربح ووقف الخسارة هي أوامر معينة مع مستوى تفعيل محدد وسعر طلب معين. عندما يصل السعر الحالي إلى مستوى التفعيل، سيتم وضع الطلب بسعر الطلب المحدد تلقائيًا، مما يساعد في حفظ الأرباح أو تقليل الخسائر.',
      text14: 'الهامش الكامل',
      text15: 'الهامش الثابت',
      text16: 'بيع',
      text17: 'شراء',
      text18: 'الرجاء إدخال السعر',
      text19: 'الرجاء إدخال الكمية',
      text20: 'تجاوز الكمية القابلة للتصفية',
      text21: 'بيع لتصفية المراكز الطويلة',
      text22: 'شراء لتصفية المراكز القصيرة',
      text23: 'بسعر السوق',
      text24: 'الرجاء إدخال الكمية',
      text25: 'الرجاء إدخال العدد',
      text26: 'تم تسوية الربح والخسارة',
      text27: 'الربح المتحقق هو الربح أو الخسارة التي تم تحقيقها وتسويتها في رصيد المستخدم، وتشمل رسوم التداول وتكاليف التمويل والربح والخسارة من التصفية والتسوية.',
      text28: 'رسوم التداول',
      text29: 'ربح وخسارة التصفية',
      text30: 'تكاليف التمويل',
      text31: 'تسوية المراكز',
      text32: 'مشترك',
    },
    setFutures: {
      titleText: 'إعدادات التداول',
      text1: 'نوع المركز',
      text2: 'لا يمكن تغيير نوع المركز بعد فتح مركز أو إعطاء أوامر معلقة',
      text3: 'مركز واحد',
      text4: 'في وضع المركز واحد، يُسمح بفتح مركز واحد فقط لكل عقد.',
      text5: 'مركز مزدوج',
      text6: 'في وضع المركز المزدوج، يُسمح بفتح مراكز طويلة وقصيرة في نفس العقد، ويُسمح بالتحوط بين المراكز.',
      text7: 'تأكيد الطلب قبل الطلب',
      text8: 'تمكين',
      text9: 'تعطيل',
      text10: 'وحدة العقد',
      text11: 'عقد',
      text12: 'حفظ',
      text13: 'صلاحية أوامر الشرط/وقف الربح ووقف الخسارة',
      text14: 'تأكيد الطلب قبل الطلب',
    },
    setMarginCoin: {
      titleText: 'تعديل الهامش لمراكز التخزين',
      text1: 'الحالي',
      text2: 'بعد التغيير',
      text3: 'المركز',
      text4: 'هامش المركز',
      text5: 'الرافعة الفعلية',
      text6: 'سعر التصفية',
      text7: 'متاح',
      text8: 'يمكن تقليل الهامش',
      text9: 'الكل',
      text10: 'زيادة الهامش',
      text11: 'تقليل الهامش',
      text12: 'رصيد غير كافٍ',
      text13: 'تقليل الهامش المتاح غير كافٍ',
      text14: '余额不足',
      text15: '可减少保证金不足',
    },
    stopOrder: {
      titleText: 'وقف الربح ووقف الخسارة',
      text1: 'وقف الربح',
      text2: 'إلغاء جميع أوامر وقف الربح',
      text3: 'سعر وقف الربح يجب أن يكون أعلى من سعر العلامة',
      text4: 'سعر وقف الربح يجب أن يكون أقل من سعر العلامة',
      text5: 'تقدير الربح والخسارة',
      text6: 'نسبة تقدير العائد',
      text7: 'وقف الخسارة',
      text8: 'إلغاء جميع أوامر وقف الخسارة',
      text9: 'سعر وقف الخسارة يجب أن يكون أقل من سعر العلامة وأعلى من سعر التصفية',
      text10: 'سعر وقف الخسارة يجب أن يكون أعلى من سعر العلامة وأقل من سعر التصفية',
      text11: 'تقدير الربح والخسارة',
      text12: 'نسبة تقدير العائد',
      text13: 'سعر تنفيذ وقف الربح',
      text14: 'سعر الطلب',
      text15: 'الكمية',
      text16: 'عقد',
      text17: 'سعر تنفيذ وقف الخسارة',
      text18: 'سعر الطلب',
      text19: 'كمية',
      text20: 'سعر',
      text21: 'سعر وقف الربح يجب أن يكون أعلى من سعر العلامة!',
      text22: 'سعر وقف الربح يجب أن يكون أقل من سعر العلامة!',
      text23: 'سعر وقف الخسارة يجب أن يكون أقل من سعر العلامة!',
      text24: 'سعر وقف الخسارة يجب أن يكون أعلى من سعر التصفية!',
      text25: 'سعر وقف الخسارة يجب أن يكون أعلى من سعر العلامة!',
      text26: 'سعر وقف الخسارة يجب أن يكون أقل من سعر التصفية!',
      text27: 'فارق السعر كبير جدًا!',
      text28: 'تجاوز الكمية القابلة للتصفية!',
      text29: 'الصلاحية',
      text30: 'سعر السوق',
      columns1: 'العقد',
      columns2: 'المركز/القابل للتصفية',
      columns3: 'سعر التكلفة',
      columns4: 'سعر العلامة',
      columns5: 'سعر التصفية',
      columns6: 'سعر وقف الربح',
      columns7: 'سعر الطلب',
      columns8: 'الكمية',
      columns9: 'سعر وقف الخسارة',
      columns10: 'أحدث الأسعار',
      time1: '24 ساعة',
      time2: '7 أيام',
      time3: '14 يومًا',
      time4: '30 يومًا',
    },
    order: {
      startTime: 'وقت البدء',
      endTime: 'وقت الانتهاء',
      coType: 'نوع العقد',
      coSide: 'اتجاه العقد',
      contract: 'العقد',
      orderType: 'نوع الأمر',
      cancelAll: 'إلغاء كل الأوامر',
      title1: 'الطلبات الحالية',
      title2: 'أوامر مخططة',
      title3: 'الطلبات السابقة',
      title4: 'أوامر مخططة سابقة',
      title5: 'الصفقات السابقة',
      typeList1: 'عقد دائم',
      typeList2: 'عقد محاكاة',
      typeList3: 'عقد مزيج',
      sideType1: 'عقد USDT',
      sideType2: 'عقد بالعملة',
      all: 'الكل',
      orderType1: 'طلب بالسعر المحدد',
      orderType2: 'طلب بالسعر السوقي',
      orderType3: 'فقط صانع',
      orderType4: 'IOC',
      orderType5: 'FOK',
      orderType6: 'الإغلاق القسري',
      orderType7: 'دمج المراكز',
      time: 'الوقت',
      side: 'الاتجاه',
      intrustPrice: 'سعر الطلب',
      intrustVolume: 'حجم الطلب (عقود)',
      dealVolume: 'حجم التنفيذ (عقود)',
      dealPrice: 'سعر التنفيذ المتوسط',
      priceDeal: 'سعر التنفيذ',
      onlyCut: 'تخفيض الوظيفة فقط',
      opera: 'العمليات',
      triggerPrice: 'سعر الزناد',
      intrustVolumeOrNum: 'حجم الطلب / القيمة',
      overTime: 'وقت الانتهاء',
      status: 'الحالة',
      submitTime: 'وقت تقديم الطلب',
      triggerTime: 'وقت الزناد',
      roles: 'الأدوار',
      fee: 'الرسوم',
      status1: 'أمر جديد',
      status2: 'تنفيذ كامل',
      status3: 'تنفيذ جزئي',
      status4: 'تم إلغاء الأمر',
      status5: 'قيد الإلغاء',
      status6: 'أمر غير معتاد',
      status7: 'تم إلغاء الجزء والتنفيذ',
      contractType1: 'دائم',
      contractType2: 'هذا الأسبوع',
      contractType3: 'الأسبوع القادم',
      contractType4: 'شهري',
      contractType5: 'ربع سنوي',
      statusText1: 'فعال',
      statusText2: 'تم الإلغاء',
      statusText3: 'تم الانتهاء',
      statusText4: 'فشل الأمر',
      open: 'فتح',
      close: 'إغلاق',
      buy: 'شراء',
      sell: 'بيع',
      currentPrice: 'السعر الحالي',
      yes: 'نعم',
      no: 'لا',
      per: 'عقد',
      cancel: 'إلغاء',
      memoText1: 'إلغاء من قبل المستخدم',
      memoText2: 'انتهاء الصلاحية',
      memoText3: 'السعر الحالي يصل إلى',
      memoText4: 'فشل التنفيذ بسبب عدم كفاية رصيد الهامش في الحساب',
      memoText5: 'فشل التنفيذ بسبب عدم كفاية الكمية الممكنة للإغلاق',
      memoText6: 'فشل التنفيذ بسبب الإغلاق القسري للمراكز',
      memoText7: 'فشل التنفيذ بسبب تعليق التداول في هذا العقد',
    },
    coFlowingWater: {
      startTime: 'وقت البدء',
      endTime: 'وقت الانتهاء',
      coin: 'العملة',
      type: 'النوع',
      all: 'الكل',
      transferIn: 'تحويل إلى',
      transferOut: 'تحويل من',
      fee: 'رسوم الأموال',
      loss: 'توزيع الخسائر',
      time: 'الوقت',
      amount: 'المبلغ',
      typeList1: 'توزيع الرسوم',
      typeList2: 'منحة هدايا',
      typeList3: 'استرداد هدايا',
      typeList4: 'رسوم الإغلاق',
      typeList5: 'رسوم الفتح',
    },
    coAccount: {
      coAccount: 'حساب العقد',
      transfer: 'نقل',
      coin: 'العملة',
      canUser: 'قابل للإستخدام',
      allBalance: 'الإجمالي',
      allMargin: 'ضمان الهامش الكلي',
      subMargin: 'ضمان الهامش المفصل',
      lockMargin: 'ضمان الهامش المجمد',
      opera: 'العمليات',
    },
    transfer: {
      transfer: 'نقل الأموال',
      from: 'من',
      to: 'إلى',
      coin: 'العملة',
      volume: 'الكمية المنقولة',
      volumeError: 'الكمية المتاحة غير كافية',
      all: 'الكل',
      canTransfer: 'المبلغ المتاح للنقل',
      confirm: 'تأكيد',
      cantIn: 'غير مسموح بالتحويل إلى',
      cantOut: 'غير مسموح بالتحويل من',
      exchangeAccount: 'حساب الصرف',
      coAccount: 'حساب العقد',
      noBonus: 'بدون مكافآت',
      bonusNote: 'لا يمكن سحب مكافآت التجربة مباشرة. يمكن سحب الأرباح التي تم تحقيقها منها. يمكن استخدام مكافآت التجربة في فتح مراكز تداول، ودفع رسوم التداول، وتكاليف الأموال، وتسوية الأرباح والخسائر في الإغلاق. سيتم خصم الخسائر في الإغلاق والرسوم الأخرى في النهاية من مكافآت التجربة.',
    },
    assets: {
      text1: 'الأصول',
      text2: 'معلومات العقد',
      text3: 'نقل فوري',
      text4: 'المزيد',
      text5: 'معدل الضمان في الحساب',
      text6: 'معدل الضمان في الحساب = إجمالي أصول الحساب / إجمالي الضمان المستخدم. تُستخدم هذه القيمة لتقديم تقدير تقريبي لمستوى الأصول المضمونة، حيث يزيد معدل الضمان عندما يكون الاحتمال النسبي للخسارة في الصفقات المفتوحة أقل.',
      text7: 'إجمالي الأصول',
      text8: 'إجمالي حقوق الحساب في العقود. إجمالي حقوق الحساب = إجمالي العقود بالهامش + إجمالي حقوق العقود المفتوحة + الضمان المجمد.',
      text9: 'العقود بالهامش',
      text10: 'الضمان المستخدم لضمان الصفقات بالهامش. عندما تتم إغلاق الصفقات بالهامش بشكل قوي، يتم خصم هذه الأصول.',
      text11: 'العقود المفتوحة',
      text12: 'الضمان المستخدم للعقود المفتوحة. يتم إدارة الضمان بشكل منفصل للعقود بالهامش والعقود المفتوحة.',
      text13: 'الضمان المجمد',
      text14: 'إجمالي الضمان المجمد للصفقات المرسلة.',
      text15: 'رمز العقد',
      text16: 'تاريخ التسليم',
      text17: 'عقد مرجعي',
      text18: 'مؤشر',
      text19: 'عملة الضمان',
      text20: 'قيمة العقد',
      text21: 'أدنى وحدة لتغيير السعر',
      text22: 'أدنى معدل ضمان للصفقات',
      text23: 'فترة التسوية',
      text24: [
        'مستمر',
        'أسبوعي',
        'أسبوع القادم',
        'شهري',
        'ربع سنوي',
      ],
      text25: 'بيانات العقد',
    },
    assetsChart: {
      text1: 'بالهامش',
      text2: 'مفتوح',
      text3: 'مجمد',
    },
  },
  futuresData: {
    navTitle: 'بيانات العقود',
    typeTabList1: 'عقود USDT',
    typeTabList2: 'عقود بالعملات',
    typeTabList3: 'عقود مختلطة',
    typeTabList4: 'عقود تجريبية',
    promptText1: 'عملة صندوق التأمين',
    promptText2: 'نوع العقد',
    promptText3: 'العقد',
    tabList1: 'صندوق التأمين للعقود المستمرة',
    tabList2: 'معدل الفائدة',
    tabList3: 'سعر الفهرس',
    tabList4: 'سعر العلامة',
    columns1: 'الوقت',
    columns2: 'نوع السجل',
    columns3: 'المبلغ',
    columns4: 'العقد',
    columns5: 'معدل الفائدة الحالي',
    columns6: 'البورصة',
    columns7: 'الوزن',
    tbaleTitle1: 'سجل الإيرادات والمصاريف',
    tbaleTitle2: 'البيانات التاريخية',
    tbaleTitle3: 'تكوين سعر الفهرس',
    moreText1: 'تعرف على صندوق التأمين',
    moreText2: 'تعرف على معدل الفائدة',
    moreText3: 'تعرف على سعر الفهرس',
    moreText4: 'تعرف على سعر العلامة',
    text1: 'رصيد صندوق التأمين لجميع العقود المستمرة التي تستخدم USDT كرهن هو',
    text2: 'المبالغ المضافة من أرباح الاستيلاء',
    text3: 'المصاريف المسحوبة من صندوق الاحتياطي للمخاطر',
  },
  creditCard: {
    title: 'معاملات البطاقة الائتمانية',
    amount: 'حجم الشراء',
    num: 'المبلغ (باستثناء الرسوم)',
    buy: 'اشتر الآن',
    mark: 'منصة مال: شراء عملة رقمية بسهولة وسرعة وأمان. جميع البطاقات الرئيسية و ابل باي مقبولة',
    warnTit: 'ملاحظة',
    warn1: '1.سعر العملة الرقمية الحالي وليس السعر النهائي. اذا تغير السعر أكثر من +/- 2.5٪ ، يرسل منصة مال تأكيدًا لإعادة الصفقة ',
    warn2: '2. عرض $ <حالة الطلب> $ على منصة مال و $ <سجل الإيداع> $ على البورصة بعد الشراء',
    warn3: '3. للاستفسارات ، اتصل بـ support@mal.io',
    confirmTit: 'إعادة التوجيه إلى منصة مال',
    confirmBtn: 'انتقل إلى منصة مال للدفع',
    confirmText1: 'تودع منصة مال العملة الرقمية التي تم شراؤها في حسابك خلال 2-10 دقائق بعد الدفع',
    confirmText2: 'منصة مال، هي منصة عملات رقمية وفيات، تعمل بشكل مستقل. البورصة ليست مسؤولة عن الخسائر الناجمة عن استخدام هذه الخدمة',
    callBackTit: 'الآراء والاقتراحات للدفع',
    callBackTrue: 'تداول',
    callBackFalse: 'عرض الأصول',
    callBackText1: '1. بعد الدفع ، تلقي بريدًا إلكترونيًا من منصة مال. $ <تحقق من حالة الدفع> $ على منصة مال',
    callBackText2: '2. تقوم منصة مال بالتحويل الى حسابك بعد الدفع',
    callBackText3: '3. للاستفسارات ، اتصل بـ support@mal.io',
  },
};
